export const translations = {
  en: {
    // Header
    appName: "MyBoki.Me",
    appTitle: "📚 myboki.me",
    appSubtitle: "",

    // Tab Navigation
    tabBookmarks: "Bookmarks",
    tabGroups: "Groups",
    tabReminders: "Reminders",

    // Main buttons
    addNewBookmark: "➕ Add New Bookmark",
    
    // Form labels and buttons
    editBookmark: "Edit Bookmark",
    addBookmark: "Add New Bookmark",
    title: "Title",
    url: "URL",
    description: "Description",
    titlePlaceholder: "Enter bookmark title",
    urlPlaceholder: "Enter website URL (e.g., google.com)",
    descriptionPlaceholder: "Optional description",
    updateBookmark: "Update Bookmark",
    addBookmarkBtn: "Add Bookmark",
    cancel: "Cancel",
    saving: "Saving...",
    
    // Bookmark item actions
    visit: "🔗 Visit",
    open: "Open",
    edit: "Edit",
    delete: "Delete",
    share: "Share",
    remindMe: "Remind me",

    // Reminder dialog
    createReminder: "Create Reminder",
    frequency: "Frequency",
    reminderOnce: "Once",
    reminderDaily: "Daily",
    reminderWeekly: "Weekly",
    reminderMonthly: "Monthly",
    quickReminder: "Quick Remind",
    in30Min: "In 30 min",
    in1Hour: "In 1 hour",
    in3Hours: "In 3 hours",
    tomorrow: "Tomorrow",
    nextWeek: "Next week",
    customDateTime: "Custom Date & Time",
    create: "Create",
    pleaseSelectDateTime: "Please select date and time",
    notificationsDenied: "Push notifications are blocked. Please enable them in browser settings.",
    reminderCreated: "Reminder created!",

    // Search and sort
    searchBookmarks: "Search... (e.g. \"3 stars\" or \"2 stars cake\")",
    searchPlaceholder: "🔍 Search bookmarks...",
    sortBy: "Sort by:",
    newest: "Newest First",
    oldest: "Oldest First",
    titleSort: "Title A-Z",
    urlSort: "URL A-Z",
    favorites: "Favorites Only",
    
    // Favorites
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    showFavorites: "Show Favorites",
    showAll: "Show All",
    
    // Empty state
    noBookmarks: "No bookmarks yet!",
    noBookmarksDesc: "Add your first bookmark to get started.",
    noResults: "No bookmarks found matching",
    noResultsFound: "No results found",
    tryDifferentSearch: "Try a different search term",
    
    // Bookmark details
    fullUrl: "Full URL:",
    created: "Created:",
    updated: "Updated:",
    
    // Footer
    totalBookmarks: "Total bookmarks:",
    
    // Pagination
    showing: "Showing",
    of: "of",
    bookmarks: "bookmarks",
    previous: "Previous",
    next: "Next",
    
    // Validation messages
    titleRequired: "Title is required",
    urlRequired: "URL is required",
    invalidUrl: "Please enter a valid URL",
    
    // Confirmation
    deleteConfirm: "Are you sure you want to delete this bookmark?",
    logoutConfirm: "Are you sure you want to logout?",
    
    // Authentication
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    name: "Name",
    confirmPassword: "Confirm Password",
    emailPlaceholder: "Enter your email address",
    passwordPlaceholder: "Enter your password",
    namePlaceholder: "Enter your full name",
    confirmPasswordPlaceholder: "Confirm your password",
    loginBtn: "Login",
    registerBtn: "Create Account",
    loading: "Loading...",
    forgotPassword: "Forgot Password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    registerLink: "Sign up",
    loginLink: "Sign in",
    welcomeBack: "Welcome back",
    loggedInAs: "Logged in as",
    
    // Validation messages
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    nameRequired: "Name is required",
    invalidEmail: "Please enter a valid email address",
    passwordTooShort: "Password must be at least 6 characters",
    passwordsDoNotMatch: "Passwords do not match",
    
    goOnline: "Go Online",
    goOffline: "Go Offline",
    switchToOnline: "Switch to online mode",
    switchToOffline: "Switch to offline mode",

    // Voice Control
    voiceControlTitle: "Voice Control",
    privacyFirst: "Privacy First",
    onDeviceProcessing: "On-Device Processing",
    noDataTransmission: "No Data Transmission",
    gdprCompliant: "GDPR Compliant",
    exampleCommands: "Example Commands",
    activateVoiceControl: "Activate Voice Control",
    continueWithoutVoice: "Continue Without Voice",
    loadingModel: "Loading speech model...",
    listening: "Listening...",
    commandNotRecognized: "Command not recognized",
    commandRecognized: "Command recognized",
    stopListening: "Stop listening",
    startListening: "Start voice input",
    showVoiceHelp: "Show voice commands",
    revokeVoiceConsent: "Disable voice control",
    voiceCommands: "Voice Commands",
    closeHelp: "Close help",
    closeError: "Close error",
    voiceTips: "Tips",
    speakClearly: "Speak clearly at normal volume",
    waitForBeep: "Wait for microphone icon before speaking",
    shortCommands: "Use short, clear commands",
    browserBased: "Browser-based",
    instantReady: "Instantly ready",
    privacyNote: "Privacy note",
    commandCategoryonline: "Online Mode",
    commandCategorysystem: "System",
    
    // Password Reset
    forgotPasswordTitle: "Forgot Password?",
    forgotPasswordDescription: "Enter your email address and we'll send you a link to reset your password.",
    emailSentTitle: "Email Sent",
    emailSentMessage: "If the email address exists in our system, you will receive a password reset link shortly.",
    checkEmailInstruction: "Please check your email inbox and follow the instructions in the email.",
    backToLogin: "Back to Login",
    sendResetLink: "Send Reset Link",
    sendingResetLink: "Sending...",
    resetPasswordTitle: "Reset Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    newPasswordPlaceholder: "Enter new password",
    confirmNewPasswordPlaceholder: "Confirm new password",
    updatePassword: "Update Password",
    updatingPassword: "Updating...",
    passwordUpdatedTitle: "Password Updated",
    passwordUpdatedMessage: "Your password has been successfully updated. You can now login with your new password.",
    proceedToLogin: "Continue to Login",
    invalidResetToken: "Invalid or expired reset token",
    passwordResetError: "An error occurred. Please try again later.",
    sessionExpiredSecurity: "You have been logged out for security reasons because your session has expired.",
    offlineTimeout: "You have been offline for too long. Please log in again.",
    offlineBanner: "You are offline. Changes will sync when connection is restored.",
    offlineChangesStored: "Changes are being stored locally",

    // Sync Status
    syncStatus: "Sync status",
    syncing: "Syncing...",
    pendingChanges: "pending changes",
    allSynced: "All synced",
    syncConflict: "Sync conflict",
    conflictDescription: "This data was modified elsewhere while you were offline.",
    keepLocal: "Keep my version",
    keepServer: "Use server version",
    mergeChanges: "Merge changes",
    localVersion: "Your version",
    serverVersion: "Server version",
    resolving: "Resolving...",
    lastUpdate: "Last update",
    items: "Items",
    noData: "No data",

    back: "Back",
    
    // HamburgerMenu
    categories: "Categories",
    voiceControl: "Voice Commands",
    startVoiceInput: "Activate Voice Input",
    stopVoiceInput: "Stop Voice Input",
    themes: "Themes",
    selectTheme: "Themes",
    privacy: "Privacy",
    settings: "Settings",
    support: "Support", 
    'version.title': 'Version',
    'version.current': 'Currently installed version',
    'version.upToDate': 'You are using the latest version.',
    language: "Language",
    upgradeBeta: "Try Beta",

    // Settings
    'settings.notifications': 'Notifications',
    'settings.pushNotifications': 'Enable push notifications',
    'settings.dataBackup': 'Data Backup',
    'settings.autoBackup': 'Automatic data backup',
    'settings.general': 'General',
    'settings.language': 'Language',
    'settings.selectLanguage': 'Select language',
    'settings.voiceControl': 'Voice Control',
    'settings.voiceActivate': 'Enable voice commands',
    'settings.voicePrivacyRevoke': 'Revoke voice consent',
    'settings.save': 'Save',
    'settings.saved': 'Settings saved!',

    // Menu
    'menu.bookmarks': 'Bookmarks',
    'menu.allBookmarks': 'Overview',
    'menu.profile': 'Profile',
    'menu.version': 'Version',
    'menu.todo': 'To-Do',
    'menu.reminders': 'Reminders',
    'menu.calendar': 'Calendar',

    // Navigation Settings
    'settings.navigation': 'Navigation',
    'settings.navDescription': 'Choose up to 3 items to display in the navigation bar.',
    'settings.navMaxThree': 'Maximum 3 items can be selected',
    'settings.navMinOne': 'At least 1 item must be selected',
    'settings.navMoveUp': 'Move up',
    'settings.navMoveDown': 'Move down',

    // Profile Settings
    'settings.profile': 'Profile',
    'settings.profileDescription': 'Manage your email address, password and account.',
    'settings.currentEmail': 'Email address',
    'settings.newEmail': 'New email address',
    'settings.changeEmail': 'Change email address',
    'settings.applyChange': 'Update',
    'settings.emailChanged': 'Email address successfully changed.',
    'settings.emailChangeError': 'Error changing email address. Please try again.',
    'settings.currentPassword': 'Current password',
    'settings.newPassword': 'New password',
    'settings.confirmNewPassword': 'Confirm new password',
    'settings.changePasswordBtn': 'Change password',
    'settings.passwordChanged': 'Password successfully changed.',
    'settings.passwordChangeError': 'Error changing password. Please check your current password.',
    'settings.deleteAccountTitle': 'Delete Account',
    'settings.deleteAccountWarning': 'Permanently deletes all your data (bookmarks, shopping lists, recipes, reminders, shared links). Cannot be undone.',
    'settings.deleteAccountPasswordLabel': 'Confirm with your password',
    'settings.deleteAccountButton': '🗑️ Delete permanently',
    'settings.deleteAccountConfirm': 'Are you sure you want to permanently delete your account? All your data will be irrevocably deleted. This action cannot be undone.',
    'settings.accountDeleted': 'Your account has been successfully deleted.',
    'settings.accountDeleteError': 'Error deleting account. Please try again or contact support.',
    'settings.passwordRequiredForAction': 'Please enter your password to confirm.',
    'settings.confirmWithPassword': 'Confirm the change with your password',
    'settings.nothingToChange': 'Please enter a new email address and/or a new password.',

    'nav.bookmarks': 'Bookmarks',
    'nav.reminders': 'Reminders',
    'nav.quickList': 'Shopping List',
    'nav.todo': 'To-Do',
    'nav.recipes': 'Recipes',

    // Reminders (Calendar view + create dialog)
    'reminders.title': 'Calendar',
    'reminders.month': 'Month',
    'reminders.week': 'Week',
    'reminders.today': 'Today',
    'reminders.previous': 'Previous',
    'reminders.next': 'Next',
    'reminders.viewMode': 'View',
    'reminders.noRemindersThisDay': 'No reminders on this day',
    'reminders.deleteConfirm': 'Really delete this reminder?',
    'reminders.frequencyCustom': 'Custom',
    'reminders.editTitle': 'Edit reminder',
    'reminders.titleLabel': 'Title',
    'reminders.titleRequired': 'Please enter a title',
    'reminders.save': 'Save',
    'reminders.saving': 'Saving...',
    'reminders.saved': 'Reminder updated.',
    'reminders.saveError': 'Error while saving.',
    'reminders.close': 'Close',
    'reminders.editAction': 'Edit',
    'reminders.deleteAction': 'Delete',
    'reminders.activate': 'Activate',
    'reminders.deactivate': 'Deactivate',
    'reminders.openBookmark': 'Open bookmark',

    // Export Dialog
    exportBookmarks: "Export Bookmarks",
    exportInstructions: "Export Instructions",
    exportStep1: "Click 'Export' to create an HTML file",
    exportStep2: "The file will be saved in Netscape Bookmark format",
    exportStep3: "Import the file into your browser:",
    browserSupport: "Browser Support",
    chromeInstructions: "Settings → Bookmarks → Import bookmarks and settings",
    firefoxInstructions: "Bookmarks → Manage bookmarks → Import and Backup → Import Bookmarks from HTML",
    safariInstructions: "File → Import Bookmarks",
    exportSummary: "Export Summary",
    withDescription: "With Description",
    previewFirst5: "Preview (first 5 bookmarks)",
    andMore: "and",
    moreBookmarks: "more bookmarks",
    exportCompleted: "Export Completed!",
    exportSuccessMessage: "Your bookmarks have been successfully exported. The file has been saved to your Downloads folder.",
    autoCloseMessage: "This window will close automatically in a few seconds...",
    exporting: "Exporting...",
    exportNow: "Export",
    
    // Share functionality
    shareBookmark: "Share bookmark",
    copyLink: "Copy link",
    linkCopied: "Link copied to clipboard!",
    copyFailed: "Copy failed",

    // Settings options
    autoRemoveInvalidLinks: "Automatically remove invalid links",
    autoRemoveInactiveReminders: "Automatically remove inactive reminders",


    // Recipe Menu
    'menu.recipes': 'Recipes',
    'menu.recipesOverview': 'My Collection',
    'menu.shoppingList': 'Shopping',
    'menu.quickList': 'Shop Today',
    'menu.archive': 'Recipe Archive',
    'menu.dataArchive': 'Archive',

    // Quick Shopping List
    'quickList.title': 'Shopping today',
    'quickList.addItem': 'Add item',
    'quickList.progress': '{completed} of {total} done',
    'quickList.error': 'Error loading shopping list',
    'quickList.addError': 'Error adding item',
    'quickList.duplicateItem': 'Item already exists in the list',
    'quickList.placeholder': 'Add item...',
    'quickList.empty': 'No items yet',
    'quickList.emptyHint': 'Add your first item!',
    'quickTodo.error': 'Error loading to-do list',
    'quickTodo.duplicateItem': 'Task already exists in the list',
    'quickTodo.addError': 'Error adding task',
    'quickTodo.removeError': 'Error removing task',
    'quickTodo.progress': '{completed} of {total} done',
    'quickTodo.placeholder': 'Add task...',
    'quickTodo.sharedList': 'Shared To-Do List',
    'quickTodo.privateList': 'Private To-Do List',
    'quickTodo.activelyShared': '(Actively shared)',
    'quickTodo.primaryList': '(Primary list)',
    'quickTodo.private': '(Private)',
    'quickTodo.refresh': 'Refresh',
    'quickTodo.switchList': 'Manage lists',
    'quickTodo.switchListTitle': 'Choose to-do list',
    'quickTodo.noOtherLists': 'No other lists available',
    'quickTodo.newList': 'Create new list',
    'quickTodo.slotPrimary': 'Main list',
    'quickTodo.slotSecondary': 'Second list',
    'quickTodo.confirmDeleteList': 'Delete this list permanently?',
    'quickTodo.deleteListError': 'Error deleting the list',
    'quickTodo.empty': 'No tasks yet',
    'quickTodo.emptyHint': 'Add your first task!',
    'quickTodo.addSecondary': 'Second to-do list',
    'quickTodo.removeSecondary': 'Remove second list',
    'quickTodo.addSecondaryError': 'Error creating second list',
    'quickList.viewAll': 'All Lists',
    'quickList.refresh': 'Refresh',
    'quickList.switchList': 'Manage lists',
    'quickList.switchListTitle': 'Choose shopping list',
    'quickList.noOtherLists': 'No other lists available',
    'quickList.newList': 'Create new list',
    'quickList.slotPrimary': 'Main list',
    'quickList.slotSecondary': 'Second list',
    'quickList.confirmDeleteList': 'Delete this list permanently?',
    'quickList.deleteListError': 'Error deleting the list',
    'quickList.sharedList': 'Shared List',
    'quickList.privateList': 'Private List',
    'quickList.activelyShared': '(Actively shared)',
    'quickList.private': '(Private)',
    'quickList.setAsSecondary': 'Set as second "Today" list',
    'quickList.removeSecondary': 'Remove from "Today"',
    'quickList.primaryList': '(Primary list)',

    // Share Feature
    'share.title': 'Share List',
    'share.shareList': 'Share list',
    'share.sharedList': 'Shared list',
    'share.linkTab': 'Share Link',
    'share.collaboratorsTab': 'Collaborators',
    'share.createLink': 'Create share link',
    'share.copy': 'Copy',
    'share.copied': 'Copied!',
    'share.shareVia': 'Share via...',
    'share.expiresIn24h': 'Link is valid for 24 hours',
    'share.description': 'Create a link and share it. Anyone with the link can edit the list.',
    'share.activeShares': 'Active links',
    'share.uses': 'uses',
    'share.revoke': 'Revoke',
    'share.noCollaborators': 'No collaborators yet',
    'share.removeCollaborator': 'Remove',
    'share.onlyOwnerCanShare': 'Only the owner can share this list.',
    'share.error': 'Error creating share link',
    'share.defaultTitle': 'Shopping List',
    'share.inviteText': 'Join my shopping list',
    'share.invalidLink': 'Invalid share link',
    'share.loadError': 'Error loading share info',
    'share.joinError': 'Error joining list',
    'share.invalidTitle': 'Invalid Link',
    'share.backHome': 'Back to home',
    'share.joinTitle': 'Join Shopping List',
    'share.listName': 'List',
    'share.owner': 'Created by',
    'share.items': 'Items',
    'share.expiresIn': 'Valid for',
    'share.expired': 'Expired',
    'share.joinNow': 'Join now',
    'share.loginToJoin': 'Login & Join',
    'share.cancel': 'Cancel',
    'share.loginRequired': 'You must be logged in to join the list.',
    'share.loading': 'Loading share info...',
    'share.alreadyMember': 'You are already a member',
    'share.joinSuccess': 'Successfully joined!',
    'share.redirecting': 'Redirecting...',
    'share.sharedBy': 'Shared by',
    'share.exitSharedList': 'My list',
    'share.existingLinkDescription': 'You already have an active share link. Share it with others.',
    'share.collaboratorsActive': 'collaborators have access',
    'share.usesViaLink': 'joins via link',
    'share.inviteMore': 'Invite more people',
    'share.removeCollaboratorConfirm': 'Really remove',
    'share.revokeConfirmWithCollaborators': 'If you delete the link, all collaborators will lose access to this list. Continue?',
    'share.linkCreatedAndCopied': 'Link created and copied!',
    'share.linkCreated': 'Link created!',
    'share.manageLinks': 'Link Management',
    'share.linkExpired': 'Expired',
    'share.linkActive': 'Active',
    'share.deleteLink': 'Delete link',
    'share.expiredLinkDeleted': 'Expired link deleted',

    // Recipes List
    'recipes.title': 'Recipes',
    'recipes.searchPlaceholder': 'Search recipes...',
    'recipes.noRecipes': 'No recipes found',
    'recipes.noRecipesHint': 'Bookmarks with keywords like "recipe", "ingredients" are automatically detected',
    'recipes.createShoppingList': 'Create Shopping List',
    'recipes.viewRecipe': 'View Recipe',
    'recipes.archive': 'Archive',
    'recipes.confirmArchive': 'Archive this recipe?',
    'recipes.archived': 'Recipe has been archived',
    'recipes.listCreated': 'Shopping list created!',
    'recipes.addedToCart': 'Added to shopping cart!',
    'recipes.addToCart': 'Add to Shopping Cart',
    'recipes.addToShoppingList': 'Add to Shopping List',
    'recipes.addedToList': 'Added to shopping list!',
    'recipes.listAddError': 'Error adding to shopping list',
    'recipes.pickShoppingList': 'Which shopping list should this be added to?',
    'recipes.newShoppingList': '+ Create new list',
    'recipes.newShoppingListPlaceholder': 'Name of the new list (optional)',
    'recipes.noIngredients': 'No ingredients available for this recipe. Please edit the recipe and add ingredients.',
    'recipes.extractionInfo': 'Ingredients for this recipe have not been loaded yet. Click the button to automatically load ingredients from the recipe website.',
    'recipes.extractIngredients': 'Load ingredients from website',
    'recipes.extracting': 'Loading ingredients...',
    'recipes.extractionError': 'Error loading ingredients. The website may not support automatic detection.',
    'recipes.instagramNotSupported': 'Instagram does not support automatic recipe extraction. You can create the recipe manually.',
    'recipes.createManually': 'Create recipe manually',
    'recipes.openInInstagram': 'Open in Instagram',
    'recipes.viewOriginal': 'View original recipe',
    'recipes.baseServings': 'Base Servings',
    'recipes.targetServings': 'Target Servings',
    'recipes.ingredients': 'Ingredients',
    'recipes.manualRecipes': 'My Recipes',
    'recipes.bookmarkRecipes': 'Recipe Bookmarks',
    'recipes.servings': 'Servings',
    'recipes.quantity': 'Quantity',
    'recipes.unit': 'Unit',
    'recipes.ingredient': 'Ingredient',
    'recipes.note': 'Note',
    'recipes.servingsQuestion': 'For how many people would you like to cook?',
    'recipes.confirm': 'Confirm',
    'recipes.cancel': 'Cancel',
    'recipes.close': 'Close',
    'recipes.print': 'Print',
    'recipes.instructions': 'Instructions',
    'recipes.addStep': 'Add Step',
    'recipes.removeStep': 'Remove Step',
    'recipes.stepPlaceholder': 'Describe this preparation step...',
    'recipes.notOnlineRecipeHint': 'This is not an online recipe. Please use the "View Recipe" menu button.',

    // Recipe Form (CRUD)
    'recipes.form.createTitle': 'Create New Recipe',
    'recipes.form.editTitle': 'Edit Recipe',
    'recipes.form.saveAndClose': 'Save and close',
    'recipes.form.newRecipe': 'New Recipe',
    'recipes.form.title': 'Recipe Name',
    'recipes.form.titleRequired': 'Recipe name is required',
    'recipes.form.description': 'Description',
    'recipes.form.baseServings': 'Base Servings',
    'recipes.form.servingsInvalid': 'At least 1 serving required',
    'recipes.form.difficulty': 'Difficulty',
    'recipes.form.prepTime': 'Preparation Time',
    'recipes.form.cookTime': 'Cooking Time',
    'recipes.form.minutes': 'minutes',
    'recipes.form.addIngredient': 'Add Ingredient',
    'recipes.form.ingredientName': 'Ingredient',
    'recipes.form.note': 'Note',
    'recipes.form.create': 'Create Recipe',
    'recipes.form.update': 'Update Recipe',
    'recipes.form.confirmDelete': 'Really delete this recipe?',
    'recipes.form.deleteSuccess': 'Recipe deleted',
    'recipes.form.createSuccess': 'Recipe created',
    'recipes.form.updateSuccess': 'Recipe updated',
    'recipes.difficulty.easy': 'Easy',
    'recipes.difficulty.medium': 'Medium',
    'recipes.difficulty.hard': 'Hard',

    // Shopping List
    'shoppingList.title': 'Shopping Lists',
    'shoppingList.all': 'All',
    'shoppingList.open': 'Open',
    'shoppingList.completed': 'Completed',
    'shoppingList.noLists': 'No shopping lists',
    'shoppingList.noListsHint': 'Create a shopping list from a recipe',
    'shoppingList.items': 'items',
    'shoppingList.created': 'Created',
    'shoppingList.selectList': 'Select a shopping list',
    'shoppingList.confirmDelete': 'Delete this shopping list?',
    'shoppingList.edit': 'Edit',
    'shoppingList.save': 'Save',
    'shoppingList.cancel': 'Cancel',
    'shoppingList.addItem': 'Add Item',
    'shoppingList.newItemPlaceholder': 'e.g. Tomatoes',
    'shoppingList.empty': 'No shopping lists',
    'shoppingList.backToList': 'Back to Overview',
    'shoppingList.more': 'more',
    'shoppingList.editMode': 'Edit Shopping List',
    'shoppingList.newList': '+ New Shopping List',
    'shoppingList.manualTitle': 'New Shopping List',
    'shoppingList.name': 'Name',
    'shoppingList.namePlaceholder': 'e.g. Weekly shopping, Hardware store, Saturday party',
    'shoppingList.description': 'Description (optional)',
    'shoppingList.descriptionPlaceholder': 'Notes for the shopping list...',
    'shoppingList.create': 'Create',
    'shoppingList.nameRequired': 'Please enter a name',
    'shoppingList.itemName': 'Item',
    'shoppingList.itemQuantity': 'Quantity',
    'shoppingList.itemUnit': 'Unit',
    'shoppingList.searchPlaceholder': 'Search lists...',
    'shoppingList.noResults': 'No lists found',
    'shoppingList.enterListName': 'Enter list name...',
    'shoppingList.addDescription': 'Add description',
    'shoppingList.confirmName': 'Confirm name',
    'shoppingList.addItemPlaceholder': 'Add item...',

    // Archive
    'archive.title': 'Recipe Archive',
    'archive.info': 'The archive stores recipes as snapshots in case the original URL disappears or a cleanup job removes invalid bookmarks.',
    'archive.noArchived': 'No archived recipes',
    'archive.noArchivedHint': 'Archive recipes to keep a permanent copy',
    'archive.open': 'Open',
    'archive.archivedOn': 'Archived on',
    'archive.originalUrl': 'Original URL',
    'archive.category': 'Category',
    'archive.snapshot': 'Snapshot',

    // Data Archive (trash / restore for categories, bookmarks, recipes, shopping lists)
    'dataArchive.title': 'Archive',
    'dataArchive.intro': 'Deleted categories, bookmarks, recipes and shopping lists land here automatically and can be restored from here.',
    'dataArchive.filterAll': 'All',
    'dataArchive.empty': 'No archived items',
    'dataArchive.emptyHint': 'Deleted categories, bookmarks, recipes and shopping lists will appear here.',
    'dataArchive.badgeDeleted': 'Deleted',
    'dataArchive.badgeSnapshot': 'Automatic backup',
    'dataArchive.restore': 'Restore',
    'dataArchive.restoreSuccess': 'Successfully restored',
    'dataArchive.restoreError': 'Restore failed',
    'dataArchive.restoreExists': 'Already exists, not restored',
    'dataArchive.removeConfirm': 'Permanently remove this entry from the archive? (Cannot be undone)',
    'dataArchive.removePermanently': 'Remove permanently',
    'dataArchive.noTitle': '(untitled)',
    'dataArchive.viewContent': 'View content',
    'dataArchive.source': 'Source',
    'dataArchive.author': 'Author',
    'dataArchive.archivedNotice': 'Archived version from {date} – see link above for the original. The content may have changed or is no longer available.',
    'dataArchive.removeError': 'Failed to remove',
    'dataArchive.contentNotFound': 'No archived content available.',

    // Bookmark Form
    rating: "Rating",
    category: "Category",
    noRating: "No rating",
    createCategory: "Create",
    hideInput: "Hide input",
    newCategoryTitle: "Create new category",
    newCategoryPlaceholder: "Enter new category...",

    // Bookmark Categories (auto-detected)
    'categories.work': 'Work',
    'categories.dev': 'Dev',
    'categories.ai': 'AI',
    'categories.design': 'Design',
    'categories.tools': 'Tools',
    'categories.news': 'News',
    'categories.shopping': 'Shopping',
    'categories.deals': 'Deals',
    'categories.finance': 'Finance',
    'categories.food': 'Food',
    'categories.travel': 'Travel',
    'categories.fitness': 'Fitness',
    'categories.entertainment': 'Entertainment',
    'categories.gaming': 'Gaming',
    'categories.diy': 'DIY',
    'categories.inbox': 'Inbox',
    'categories.important': 'Important',
    'categories.random': 'Random',
    'categories.other': 'Other',

    // Category Management
    'categories.title': 'Categories',
    'categories.placeholder': 'New category...',
    'categories.add': 'Add category',
    'categories.empty': 'No categories yet',
    'categories.emptyHint': 'Type a name above and tap + to create your first category!',
    'categories.emptyError': 'Category name cannot be empty',
    'categories.existsError': 'Category already exists',
    'categories.deleteConfirm': 'Delete category "{name}"? (Bookmarks will be kept)',
    'categories.searchPlaceholder': 'Search or type a new category...',
    'categories.noResults': 'No categories found',
    'categories.noResultsHint': 'Tap + above to add it as a new category'
  },
  de: {
    // Header
    appName: "MyBoki.Me",
    appTitle: "📚 myboki.me",
    appSubtitle: "",

    // Tab Navigation
    tabBookmarks: "Lesezeichen",
    tabGroups: "Gruppen",
    tabReminders: "Erinnerungen",

    // Main buttons
    addNewBookmark: "➕ Neues Lesezeichen",
    
    // Form labels and buttons
    editBookmark: "Lesezeichen bearbeiten",
    addBookmark: "Neues Lesezeichen hinzufügen",
    title: "Titel",
    url: "URL",
    description: "Beschreibung",
    titlePlaceholder: "Lesezeichen-Titel eingeben",
    urlPlaceholder: "Website-URL eingeben (z.B. google.com)",
    descriptionPlaceholder: "Optionale Beschreibung",
    updateBookmark: "Lesezeichen aktualisieren",
    addBookmarkBtn: "Lesezeichen hinzufügen",
    cancel: "Abbrechen",
    saving: "Speichere...",
    
    // Bookmark item actions
    visit: "🔗 Anzeigen",
    open: "Öffnen",
    edit: "Bearbeiten",
    delete: "Löschen",
    share: "Teilen",
    remindMe: "Erinnere mich",

    // Reminder dialog
    createReminder: "Erinnerung erstellen",
    frequency: "Wiederholung",
    reminderOnce: "Einmalig",
    reminderDaily: "Täglich",
    reminderWeekly: "Wöchentlich",
    reminderMonthly: "Monatlich",
    quickReminder: "Schnell erinnern",
    in30Min: "In 30 Min",
    in1Hour: "In 1 Stunde",
    in3Hours: "In 3 Stunden",
    tomorrow: "Morgen",
    nextWeek: "Nächste Woche",
    customDateTime: "Eigenes Datum & Uhrzeit",
    create: "Erstellen",
    pleaseSelectDateTime: "Bitte Datum und Uhrzeit auswählen",
    notificationsDenied: "Push-Benachrichtigungen wurden blockiert. Bitte aktiviere sie in den Browser-Einstellungen.",
    reminderCreated: "Erinnerung erstellt!",

    // Search and sort
    searchBookmarks: "Suche... (z.B. \"3 Sterne\" oder \"2 Sterne Kuchen\")",
    searchPlaceholder: "🔍 Lesezeichen suchen...",
    sortBy: "Sortieren nach:",
    newest: "Neueste zuerst",
    oldest: "Älteste zuerst",
    titleSort: "Titel A-Z",
    urlSort: "URL A-Z",
    favorites: "Nur Favoriten",
    
    // Favorites
    addToFavorites: "Zu Favoriten hinzufügen",
    removeFromFavorites: "Aus Favoriten entfernen",
    showFavorites: "Favoriten anzeigen",
    showAll: "Alle anzeigen",
    
    // Empty state
    noBookmarks: "Noch keine Lesezeichen!",
    noBookmarksDesc: "Füge dein erstes Lesezeichen hinzu, um zu beginnen.",
    noResults: "Keine Lesezeichen gefunden für",
    noResultsFound: "Keine Ergebnisse gefunden",
    tryDifferentSearch: "Versuche einen anderen Suchbegriff",

    // Bookmark details
    fullUrl: "Vollständige URL:",
    created: "Erstellt:",
    updated: "Aktualisiert:",
    
    // Footer
    totalBookmarks: "Gesamte Lesezeichen:",
    
    // Pagination
    showing: "Zeige",
    of: "von",
    bookmarks: "Lesezeichen",
    previous: "Zurück",
    next: "Weiter",
    
    // Validation messages
    titleRequired: "Titel ist erforderlich",
    urlRequired: "URL ist erforderlich",
    invalidUrl: "Bitte geben Sie eine gültige URL ein",
    
    // Confirmation
    deleteConfirm: "Sind Sie sicher, dass Sie dieses Lesezeichen löschen möchten?",
    logoutConfirm: "Sind Sie sicher, dass Sie sich abmelden möchten?",
    
    // Authentication
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    confirmPassword: "Passwort bestätigen",
    emailPlaceholder: "E-Mail-Adresse eingeben",
    passwordPlaceholder: "Passwort eingeben",
    namePlaceholder: "Vollständigen Namen eingeben",
    confirmPasswordPlaceholder: "Passwort bestätigen",
    loginBtn: "Anmelden",
    registerBtn: "Konto erstellen",
    loading: "Lädt...",
    forgotPassword: "Passwort vergessen?",
    noAccount: "Noch kein Konto?",
    hasAccount: "Bereits ein Konto?",
    registerLink: "Registrieren",
    loginLink: "Anmelden",
    welcomeBack: "Willkommen zurück",
    loggedInAs: "Angemeldet als",
    
    // Validation messages
    emailRequired: "E-Mail ist erforderlich",
    passwordRequired: "Passwort ist erforderlich", 
    nameRequired: "Name ist erforderlich",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    passwordTooShort: "Passwort muss mindestens 6 Zeichen lang sein",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein",
    
    goOnline: "Online gehen",
    goOffline: "Offline gehen",
    switchToOnline: "Zum Online-Modus wechseln",
    switchToOffline: "Zum Offline-Modus wechseln",

    // Voice Control
    voiceControlTitle: "Sprachsteuerung",
    privacyFirst: "Datenschutz-First",
    onDeviceProcessing: "Lokale Verarbeitung",
    noDataTransmission: "Keine Datenübertragung",
    gdprCompliant: "DSGVO-konform",
    exampleCommands: "Beispiel-Befehle",
    activateVoiceControl: "Sprachsteuerung aktivieren",
    continueWithoutVoice: "Ohne Sprachsteuerung fortfahren",
    loadingModel: "Sprachmodell wird geladen...",
    listening: "Hört zu...",
    commandNotRecognized: "Befehl nicht erkannt",
    commandRecognized: "Befehl erkannt",
    stopListening: "Aufnahme stoppen",
    startListening: "Sprachaufnahme starten",
    showVoiceHelp: "Sprachbefehle anzeigen",
    revokeVoiceConsent: "Sprachsteuerung deaktivieren",
    voiceCommands: "Sprachbefehle",
    closeHelp: "Hilfe schließen",
    closeError: "Fehler schließen",
    voiceTips: "Tipps",
    speakClearly: "Sprechen Sie deutlich und in normaler Lautstärke",
    waitForBeep: "Warten Sie auf das Mikrofon-Symbol bevor Sie sprechen",
    shortCommands: "Verwenden Sie kurze, klare Befehle",
    browserBased: "Browser-basiert",
    instantReady: "Sofort einsatzbereit",
    privacyNote: "Datenschutz-Hinweis",
    commandCategoryonline: "Online-Modus",
    commandCategorysystem: "System",
    
    // Password Reset
    forgotPasswordTitle: "Passwort vergessen?",
    forgotPasswordDescription: "Geben Sie Ihre E-Mail Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
    emailSentTitle: "E-Mail versendet",
    emailSentMessage: "Falls die E-Mail Adresse in unserem System existiert, erhalten Sie in Kürze einen Link zum Zurücksetzen des Passworts.",
    checkEmailInstruction: "Bitte überprüfen Sie Ihr E-Mail Postfach und folgen Sie den Anweisungen in der E-Mail.",
    backToLogin: "Zurück zur Anmeldung",
    sendResetLink: "Reset-Link senden",
    sendingResetLink: "Wird gesendet...",
    resetPasswordTitle: "Passwort zurücksetzen",
    newPassword: "Neues Passwort",
    confirmNewPassword: "Neues Passwort bestätigen",
    newPasswordPlaceholder: "Neues Passwort eingeben",
    confirmNewPasswordPlaceholder: "Neues Passwort bestätigen",
    updatePassword: "Passwort aktualisieren",
    updatingPassword: "Wird aktualisiert...",
    passwordUpdatedTitle: "Passwort aktualisiert",
    passwordUpdatedMessage: "Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
    proceedToLogin: "Zur Anmeldung",
    invalidResetToken: "Ungültiger oder abgelaufener Reset-Token",
    passwordResetError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal.",
    sessionExpiredSecurity: "Sie wurden aus Sicherheitsgründen abgemeldet, weil Ihre Sitzung abgelaufen ist.",
    offlineTimeout: "Du warst zu lange offline. Bitte melde dich erneut an.",
    offlineBanner: "Du bist offline. Änderungen werden synchronisiert, sobald die Verbindung wiederhergestellt ist.",
    offlineChangesStored: "Änderungen werden lokal gespeichert",

    // Sync Status
    syncStatus: "Sync-Status",
    syncing: "Synchronisiere...",
    pendingChanges: "Änderungen ausstehend",
    allSynced: "Alles synchronisiert",
    syncConflict: "Sync-Konflikt",
    conflictDescription: "Diese Daten wurden an anderer Stelle geändert, während du offline warst.",
    keepLocal: "Meine Version behalten",
    keepServer: "Server-Version übernehmen",
    mergeChanges: "Zusammenführen",
    localVersion: "Deine Version",
    serverVersion: "Server-Version",
    resolving: "Wird aufgelöst...",
    lastUpdate: "Letzte Änderung",
    items: "Einträge",
    noData: "Keine Daten",

    back: "Zurück",

    // HamburgerMenu
    categories: "Kategorien",
    voiceControl: "Sprachbefehle",
    startVoiceInput: "Aktivieren",
    stopVoiceInput: "Spracheingabe stoppen",
    themes: "Themes",
    selectTheme: "Themes",
    privacy: "Datenschutz",
    settings: "Einstellungen",
    support: "Support",
    'version.title': 'Version',
    'version.current': 'Aktuell installierte Version',
    'version.upToDate': 'Du nutzt die aktuellste Version.',
    language: "Sprache",
    upgradeBeta: "Beta testen",

    // Settings
    'settings.notifications': 'Benachrichtigungen',
    'settings.pushNotifications': 'Push-Benachrichtigungen aktivieren',
    'settings.dataBackup': 'Datensicherung',
    'settings.autoBackup': 'Automatische Datensicherung',
    'settings.general': 'Allgemein',
    'settings.language': 'Sprache',
    'settings.selectLanguage': 'Sprache auswählen',
    'settings.voiceControl': 'Sprachsteuerung',
    'settings.voiceActivate': 'Sprachbefehle aktivieren',
    'settings.voicePrivacyRevoke': 'Sprach-Einwilligung widerrufen',
    'settings.save': 'Speichern',
    'settings.saved': 'Einstellungen gespeichert!',

    // Menu
    'menu.bookmarks': 'Lesezeichen',
    'menu.profile': 'Profil',
    'menu.version': 'Version',
    'menu.todo': 'To-Do',
    'menu.allBookmarks': 'Übersicht',
    'menu.reminders': 'Erinnerungen',
    'menu.calendar': 'Kalender',

    // Navigation Einstellungen
    'settings.navigation': 'Navigation',
    'settings.navDescription': 'Wähle bis zu 3 Elemente für die Navigationsleiste.',
    'settings.navMaxThree': 'Maximal 3 Elemente können ausgewählt werden',
    'settings.navMinOne': 'Mindestens 1 Element muss ausgewählt sein',
    'settings.navMoveUp': 'Nach oben',
    'settings.navMoveDown': 'Nach unten',

    // Profil-Einstellungen
    'settings.profile': 'Profil',
    'settings.profileDescription': 'Verwalten Sie Ihre E-Mail-Adresse, Ihr Passwort und Ihr Konto.',
    'settings.currentEmail': 'E-Mail-Adresse',
    'settings.newEmail': 'Neue E-Mail-Adresse',
    'settings.changeEmail': 'E-Mail-Adresse ändern',
    'settings.applyChange': 'Ändern',
    'settings.emailChanged': 'E-Mail-Adresse erfolgreich geändert.',
    'settings.emailChangeError': 'Fehler beim Ändern der E-Mail-Adresse. Bitte versuchen Sie es erneut.',
    'settings.currentPassword': 'Aktuelles Passwort',
    'settings.newPassword': 'Neues Passwort',
    'settings.confirmNewPassword': 'Neues Passwort bestätigen',
    'settings.changePasswordBtn': 'Passwort ändern',
    'settings.passwordChanged': 'Passwort erfolgreich geändert.',
    'settings.passwordChangeError': 'Fehler beim Ändern des Passworts. Bitte überprüfen Sie Ihr aktuelles Passwort.',
    'settings.deleteAccountTitle': 'Konto löschen',
    'settings.deleteAccountWarning': 'Löscht unwiderruflich alle Daten (Lesezeichen, Einkaufslisten, Rezepte, Erinnerungen, geteilte Links). Kann nicht rückgängig gemacht werden.',
    'settings.deleteAccountPasswordLabel': 'Mit Passwort bestätigen',
    'settings.deleteAccountButton': '🗑️ Endgültig löschen',
    'settings.deleteAccountConfirm': 'Möchten Sie Ihr Konto wirklich endgültig löschen? Alle Ihre Daten werden unwiderruflich gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    'settings.accountDeleted': 'Ihr Konto wurde erfolgreich gelöscht.',
    'settings.accountDeleteError': 'Fehler beim Löschen des Kontos. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
    'settings.passwordRequiredForAction': 'Bitte geben Sie Ihr Passwort zur Bestätigung ein.',
    'settings.confirmWithPassword': 'Bestätigen Sie die Änderung mit Ihrem Passwort',
    'settings.nothingToChange': 'Bitte geben Sie eine neue E-Mail-Adresse und/oder ein neues Passwort ein.',

    'nav.bookmarks': 'Lesezeichen',
    'nav.reminders': 'Erinnerungen',
    'nav.quickList': 'Einkaufszettel',
    'nav.todo': 'To-Do',
    'nav.recipes': 'Rezepte',

    // Erinnerungen (Kalender-Ansicht + Erstellen-Dialog)
    'reminders.title': 'Kalender',
    'reminders.month': 'Monat',
    'reminders.week': 'Woche',
    'reminders.today': 'Heute',
    'reminders.previous': 'Zurück',
    'reminders.next': 'Weiter',
    'reminders.viewMode': 'Ansicht',
    'reminders.noRemindersThisDay': 'Keine Erinnerungen an diesem Tag',
    'reminders.deleteConfirm': 'Diese Erinnerung wirklich löschen?',
    'reminders.frequencyCustom': 'Individuell',
    'reminders.editTitle': 'Erinnerung bearbeiten',
    'reminders.titleLabel': 'Titel',
    'reminders.titleRequired': 'Bitte einen Titel eingeben',
    'reminders.save': 'Speichern',
    'reminders.saving': 'Speichert...',
    'reminders.saved': 'Erinnerung aktualisiert.',
    'reminders.saveError': 'Fehler beim Speichern.',
    'reminders.close': 'Schließen',
    'reminders.editAction': 'Bearbeiten',
    'reminders.deleteAction': 'Löschen',
    'reminders.activate': 'Aktivieren',
    'reminders.deactivate': 'Deaktivieren',
    'reminders.openBookmark': 'Lesezeichen öffnen',

    // Export Dialog
    exportBookmarks: "Bookmarks exportieren",
    exportInstructions: "Export-Anweisungen",
    exportStep1: "Klicken Sie auf 'Exportieren' um eine HTML-Datei zu erstellen",
    exportStep2: "Die Datei wird im Netscape-Bookmark-Format gespeichert",
    exportStep3: "Importieren Sie die Datei in Ihren Browser:",
    browserSupport: "Browser-Unterstützung",
    chromeInstructions: "Einstellungen → Lesezeichen → Lesezeichen und Einstellungen importieren",
    firefoxInstructions: "Lesezeichen → Lesezeichen verwalten → Importieren und Sichern → Lesezeichen aus HTML importieren",
    safariInstructions: "Datei → Lesezeichen importieren",
    exportSummary: "Export-Übersicht",
    withDescription: "Mit Beschreibung",
    previewFirst5: "Vorschau (erste 5 Bookmarks)",
    andMore: "und",
    moreBookmarks: "weitere Bookmarks",
    exportCompleted: "Export abgeschlossen!",
    exportSuccessMessage: "Ihre Bookmarks wurden erfolgreich exportiert. Die Datei wurde in Ihren Downloads gespeichert.",
    autoCloseMessage: "Dieses Fenster schließt sich automatisch in wenigen Sekunden...",
    exporting: "Exportiere...",
    exportNow: "Exportieren",
    
    // Share functionality
    shareBookmark: "Bookmark teilen",
    copyLink: "Link kopieren",
    linkCopied: "Link in Zwischenablage kopiert!",
    copyFailed: "Kopieren fehlgeschlagen",

    // Einstellungen Optionen
    autoRemoveInvalidLinks: "Automatisch ungültige Links entfernen",
    autoRemoveInactiveReminders: "Automatisch deaktivierte Erinnerungen entfernen",


    // Rezepte Menü
    'menu.recipes': 'Rezepte',
    'menu.recipesOverview': 'Meine Sammlung',
    'menu.shoppingList': 'Einkauf',
    'menu.quickList': 'Heute Einkaufen',
    'menu.archive': 'Rezepte Archiv',
    'menu.dataArchive': 'Archiv',

    // Quick-Einkaufsliste
    'quickList.title': 'Heute einkaufen',
    'quickList.addItem': 'Artikel hinzufügen',
    'quickList.progress': '{completed} von {total} erledigt',
    'quickList.error': 'Fehler beim Laden der Einkaufsliste',
    'quickList.addError': 'Fehler beim Hinzufügen',
    'quickList.duplicateItem': 'Artikel ist bereits in der Liste',
    'quickList.placeholder': 'Artikel hinzufügen...',
    'quickList.empty': 'Noch keine Artikel',
    'quickList.emptyHint': 'Füge deinen ersten Artikel hinzu!',
    'quickTodo.error': 'Fehler beim Laden der To-Do-Liste',
    'quickTodo.duplicateItem': 'Aufgabe ist bereits in der Liste',
    'quickTodo.addError': 'Fehler beim Hinzufügen',
    'quickTodo.removeError': 'Fehler beim Entfernen',
    'quickTodo.progress': '{completed} von {total} erledigt',
    'quickTodo.placeholder': 'Aufgabe hinzufügen...',
    'quickTodo.sharedList': 'Geteilte To-Do-Liste',
    'quickTodo.privateList': 'Private To-Do-Liste',
    'quickTodo.activelyShared': '(Aktiv geteilt)',
    'quickTodo.primaryList': '(Hauptliste)',
    'quickTodo.private': '(Privat)',
    'quickTodo.refresh': 'Aktualisieren',
    'quickTodo.switchList': 'Listen verwalten',
    'quickTodo.switchListTitle': 'To-Do-Liste wählen',
    'quickTodo.noOtherLists': 'Keine weiteren Listen vorhanden',
    'quickTodo.newList': 'Neue Liste anlegen',
    'quickTodo.slotPrimary': 'Hauptliste',
    'quickTodo.slotSecondary': 'Zweite Liste',
    'quickTodo.confirmDeleteList': 'Diese Liste wirklich endgültig löschen?',
    'quickTodo.deleteListError': 'Fehler beim Löschen der Liste',
    'quickTodo.empty': 'Noch keine Aufgaben',
    'quickTodo.emptyHint': 'Füge deine erste Aufgabe hinzu!',
    'quickTodo.addSecondary': 'Zweite To-Do-Liste',
    'quickTodo.removeSecondary': 'Zweite Liste entfernen',
    'quickTodo.addSecondaryError': 'Fehler beim Anlegen der zweiten Liste',
    'quickList.viewAll': 'Alle Listen',
    'quickList.refresh': 'Aktualisieren',
    'quickList.switchList': 'Listen verwalten',
    'quickList.switchListTitle': 'Einkaufsliste wählen',
    'quickList.noOtherLists': 'Keine weiteren Listen vorhanden',
    'quickList.newList': 'Neue Liste anlegen',
    'quickList.slotPrimary': 'Hauptliste',
    'quickList.slotSecondary': 'Zweite Liste',
    'quickList.confirmDeleteList': 'Diese Liste wirklich endgültig löschen?',
    'quickList.deleteListError': 'Fehler beim Löschen der Liste',
    'quickList.sharedList': 'Geteilte Liste',
    'quickList.privateList': 'Private Liste',
    'quickList.activelyShared': '(Aktiv geteilt)',
    'quickList.private': '(Privat)',
    'quickList.setAsSecondary': 'Als zweite "Heute"-Liste setzen',
    'quickList.removeSecondary': 'Aus "Heute" entfernen',
    'quickList.primaryList': '(Hauptliste)',

    // Teilen-Funktion
    'share.title': 'Liste teilen',
    'share.shareList': 'Liste teilen',
    'share.sharedList': 'Geteilte Liste',
    'share.linkTab': 'Share-Link',
    'share.collaboratorsTab': 'Mitbearbeiter',
    'share.createLink': 'Share-Link erstellen',
    'share.copy': 'Kopieren',
    'share.copied': 'Kopiert!',
    'share.shareVia': 'Teilen via...',
    'share.expiresIn24h': 'Link ist 24 Stunden gültig',
    'share.description': 'Erstelle einen Link und teile ihn. Jeder mit dem Link kann die Liste bearbeiten.',
    'share.activeShares': 'Aktive Links',
    'share.uses': 'Nutzungen',
    'share.revoke': 'Widerrufen',
    'share.noCollaborators': 'Noch keine Mitbearbeiter',
    'share.removeCollaborator': 'Entfernen',
    'share.onlyOwnerCanShare': 'Nur der Besitzer kann diese Liste teilen.',
    'share.error': 'Fehler beim Erstellen des Share-Links',
    'share.defaultTitle': 'Einkaufszettel',
    'share.inviteText': 'Hier ist mein Einkaufszettel',
    'share.invalidLink': 'Ungültiger Share-Link',
    'share.loadError': 'Fehler beim Laden der Share-Informationen',
    'share.joinError': 'Fehler beim Beitreten',
    'share.invalidTitle': 'Ungültiger Link',
    'share.backHome': 'Zurück zur Startseite',
    'share.joinTitle': 'Einkaufszettel beitreten',
    'share.listName': 'Liste',
    'share.owner': 'Erstellt von',
    'share.items': 'Artikel',
    'share.expiresIn': 'Gültig noch',
    'share.expired': 'Abgelaufen',
    'share.joinNow': 'Jetzt beitreten',
    'share.loginToJoin': 'Anmelden & Beitreten',
    'share.cancel': 'Abbrechen',
    'share.loginRequired': 'Du musst angemeldet sein, um der Liste beizutreten.',
    'share.loading': 'Lade Share-Informationen...',
    'share.alreadyMember': 'Du bist bereits Mitglied',
    'share.joinSuccess': 'Erfolgreich beigetreten!',
    'share.redirecting': 'Weiterleitung...',
    'share.sharedBy': 'Geteilt von',
    'share.exitSharedList': 'Meine Liste',
    'share.existingLinkDescription': 'Du hast bereits einen aktiven Share-Link. Teile ihn mit anderen.',
    'share.collaboratorsActive': 'Mitbearbeiter haben Zugriff',
    'share.usesViaLink': 'Beitritte via Link',
    'share.inviteMore': 'Weitere Personen einladen',
    'share.removeCollaboratorConfirm': 'Wirklich entfernen',
    'share.revokeConfirmWithCollaborators': 'Wenn du den Link löschst, verlieren alle Mitbearbeiter den Zugriff auf diese Liste. Fortfahren?',
    'share.linkCreatedAndCopied': 'Link erstellt und kopiert!',
    'share.linkCreated': 'Link erstellt!',
    'share.manageLinks': 'Link-Verwaltung',
    'share.linkExpired': 'Abgelaufen',
    'share.linkActive': 'Aktiv',
    'share.deleteLink': 'Link löschen',
    'share.expiredLinkDeleted': 'Abgelaufener Link gelöscht',

    // Rezepte-Liste
    'recipes.title': 'Rezepte',
    'recipes.searchPlaceholder': 'Rezepte durchsuchen...',
    'recipes.noRecipes': 'Keine Rezepte gefunden',
    'recipes.noRecipesHint': 'Lesezeichen mit Keywords wie "Rezept", "Zutaten" werden automatisch erkannt',
    'recipes.createShoppingList': 'Einkaufszettel erstellen',
    'recipes.viewRecipe': 'Rezept ansehen',
    'recipes.archive': 'Archivieren',
    'recipes.confirmArchive': 'Rezept archivieren?',
    'recipes.archived': 'Rezept wurde archiviert',
    'recipes.listCreated': 'Einkaufszettel erstellt!',
    'recipes.addedToCart': 'Zum Einkaufskorb hinzugefügt!',
    'recipes.addToShoppingList': 'Zum Einkaufszettel',
    'recipes.addedToList': 'Zum Einkaufszettel hinzugefügt!',
    'recipes.listAddError': 'Fehler beim Hinzufügen zum Einkaufszettel',
    'recipes.pickShoppingList': 'Zu welcher Einkaufsliste hinzufügen?',
    'recipes.newShoppingList': '+ Neue Liste erstellen',
    'recipes.newShoppingListPlaceholder': 'Name der neuen Liste (optional)',
    'recipes.noIngredients': 'Keine Zutaten für dieses Rezept hinterlegt. Bitte bearbeite das Rezept und füge Zutaten hinzu.',
    'recipes.extractionInfo': 'Die Zutaten für dieses Rezept wurden noch nicht geladen. Klicke auf den Button, um die Zutaten automatisch von der Rezept-Webseite zu laden.',
    'recipes.extractIngredients': 'Zutaten von Webseite laden',
    'recipes.extracting': 'Lade Zutaten...',
    'recipes.extractionError': 'Fehler beim Laden der Zutaten. Die Webseite unterstützt möglicherweise keine automatische Erkennung.',
    'recipes.instagramNotSupported': 'Instagram unterstützt leider keine automatische Rezept-Extraktion. Du kannst das Rezept aber manuell anlegen.',
    'recipes.createManually': 'Rezept manuell anlegen',
    'recipes.openInInstagram': 'In Instagram öffnen',
    'recipes.viewOriginal': 'Original-Rezept ansehen',
    'recipes.addToCart': 'Zum Einkaufskorb hinzufügen',
    'recipes.baseServings': 'Basis-Portionen',
    'recipes.targetServings': 'Gewünschte Portionen',
    'recipes.ingredients': 'Zutaten',
    'recipes.manualRecipes': 'Meine Rezepte',
    'recipes.bookmarkRecipes': 'Rezept-Lesezeichen',
    'recipes.servings': 'Portionen',
    'recipes.quantity': 'Menge',
    'recipes.unit': 'Einheit',
    'recipes.ingredient': 'Zutat',
    'recipes.note': 'Hinweis',
    'recipes.servingsQuestion': 'Für wie viele Personen möchtest du kochen?',
    'recipes.confirm': 'Bestätigen',
    'recipes.cancel': 'Abbrechen',
    'recipes.close': 'Schließen',
    'recipes.print': 'Drucken',
    'recipes.instructions': 'Zubereitung',
    'recipes.addStep': 'Schritt hinzufügen',
    'recipes.removeStep': 'Schritt entfernen',
    'recipes.stepPlaceholder': 'Zubereitungsschritt beschreiben...',
    'recipes.notOnlineRecipeHint': 'Dies ist kein Online-Rezept. Bitte den Menüpunkt „Rezept ansehen" verwenden.',

    // Rezept-Formular (CRUD)
    'recipes.form.createTitle': 'Neues Rezept erstellen',
    'recipes.form.editTitle': 'Rezept bearbeiten',
    'recipes.form.saveAndClose': 'Speichern und schließen',
    'recipes.form.newRecipe': 'Neues Rezept',
    'recipes.form.title': 'Rezeptname',
    'recipes.form.titleRequired': 'Rezeptname ist erforderlich',
    'recipes.form.description': 'Beschreibung',
    'recipes.form.baseServings': 'Basis-Portionen',
    'recipes.form.servingsInvalid': 'Mindestens 1 Portion erforderlich',
    'recipes.form.difficulty': 'Schwierigkeitsgrad',
    'recipes.form.prepTime': 'Vorbereitungszeit',
    'recipes.form.cookTime': 'Kochzeit',
    'recipes.form.minutes': 'Minuten',
    'recipes.form.addIngredient': 'Zutat hinzufügen',
    'recipes.form.ingredientName': 'Zutat',
    'recipes.form.note': 'Hinweis',
    'recipes.form.create': 'Rezept erstellen',
    'recipes.form.update': 'Rezept aktualisieren',
    'recipes.form.confirmDelete': 'Rezept wirklich löschen?',
    'recipes.form.deleteSuccess': 'Rezept gelöscht',
    'recipes.form.createSuccess': 'Rezept erstellt',
    'recipes.form.updateSuccess': 'Rezept aktualisiert',
    'recipes.difficulty.easy': 'Einfach',
    'recipes.difficulty.medium': 'Mittel',
    'recipes.difficulty.hard': 'Schwer',

    // Einkaufszettel
    'shoppingList.title': 'Einkaufszettel',
    'shoppingList.all': 'Alle',
    'shoppingList.open': 'Offen',
    'shoppingList.completed': 'Erledigt',
    'shoppingList.noLists': 'Keine Einkaufszettel vorhanden',
    'shoppingList.noListsHint': 'Erstelle einen Einkaufszettel aus einem Rezept oder lege einen manuell an',
    'shoppingList.items': 'Artikel',
    'shoppingList.created': 'Erstellt',
    'shoppingList.selectList': 'Wähle einen Einkaufszettel aus',
    'shoppingList.confirmDelete': 'Einkaufszettel löschen?',
    'shoppingList.edit': 'Ändern',
    'shoppingList.save': 'Speichern',
    'shoppingList.newList': '+ Neuer Einkaufszettel',
    'shoppingList.createManual': 'Einkaufszettel manuell anlegen',
    'shoppingList.createFromRecipe': 'Aus Rezept erstellen',
    'shoppingList.manualTitle': 'Neuer Einkaufszettel',
    'shoppingList.name': 'Name',
    'shoppingList.namePlaceholder': 'z.B. Wocheneinkauf, Baumarkt, Party am Samstag',
    'shoppingList.description': 'Beschreibung (optional)',
    'shoppingList.descriptionPlaceholder': 'Notizen zum Einkaufszettel...',
    'shoppingList.create': 'Erstellen',
    'shoppingList.cancel': 'Abbrechen',
    'shoppingList.nameRequired': 'Bitte gib einen Namen ein',
    'shoppingList.addItem': 'Artikel hinzufügen',
    'shoppingList.itemName': 'Artikel',
    'shoppingList.itemQuantity': 'Menge',
    'shoppingList.itemUnit': 'Einheit',
    'shoppingList.newItemPlaceholder': 'z.B. Tomaten',
    'shoppingList.empty': 'Keine Einkaufszettel vorhanden',
    'shoppingList.backToList': 'Zurück zur Übersicht',
    'shoppingList.more': 'weitere',
    'shoppingList.editMode': 'Einkaufszettel bearbeiten',
    'shoppingList.emptyDualCta': 'Keine Einkaufszettel vorhanden – Erstelle einen aus einem Rezept oder lege einen manuell an',
    'shoppingList.searchPlaceholder': 'Listen suchen...',
    'shoppingList.noResults': 'Keine Listen gefunden',
    'shoppingList.enterListName': 'Listenname eingeben...',
    'shoppingList.addDescription': 'Beschreibung hinzufügen',
    'shoppingList.confirmName': 'Name bestätigen',
    'shoppingList.addItemPlaceholder': 'Artikel hinzufügen...',

    // Archiv
    'archive.title': 'Rezept-Archiv',
    'archive.info': 'Das Archiv speichert Rezepte als Snapshot, falls die Original-URL verschwindet oder ein Cleanup-Job ungültige Bookmarks entfernt.',
    'archive.noArchived': 'Keine archivierten Rezepte',
    'archive.noArchivedHint': 'Archiviere Rezepte, um eine dauerhafte Kopie zu behalten',
    'archive.open': 'Öffnen',
    'archive.archivedOn': 'Archiviert am',
    'archive.originalUrl': 'Original-URL',
    'archive.category': 'Kategorie',
    'archive.snapshot': 'Snapshot',

    // Daten-Archiv (Papierkorb / Wiederherstellung für Kategorien, Lesezeichen, Rezepte, Einkaufslisten)
    'dataArchive.title': 'Archiv',
    'dataArchive.intro': 'Gelöschte Kategorien, Lesezeichen, Rezepte und Einkaufslisten landen automatisch hier und können von dort wiederhergestellt werden.',
    'dataArchive.filterAll': 'Alle',
    'dataArchive.empty': 'Keine archivierten Elemente',
    'dataArchive.emptyHint': 'Gelöschte Kategorien, Lesezeichen, Rezepte und Einkaufslisten erscheinen hier.',
    'dataArchive.badgeDeleted': 'Gelöscht',
    'dataArchive.badgeSnapshot': 'Automatische Sicherung',
    'dataArchive.restore': 'Wiederherstellen',
    'dataArchive.restoreSuccess': 'Erfolgreich wiederhergestellt',
    'dataArchive.restoreError': 'Wiederherstellen fehlgeschlagen',
    'dataArchive.restoreExists': 'Existiert bereits, nicht wiederhergestellt',
    'dataArchive.removeConfirm': 'Diesen Eintrag endgültig aus dem Archiv entfernen? (Kann nicht rückgängig gemacht werden)',
    'dataArchive.removePermanently': 'Endgültig entfernen',
    'dataArchive.noTitle': '(ohne Titel)',
    'dataArchive.viewContent': 'Inhalt ansehen',
    'dataArchive.source': 'Quelle',
    'dataArchive.author': 'Autor',
    'dataArchive.archivedNotice': 'Archivierte Version vom {date} – Original siehe Link oben. Der Inhalt kann sich seitdem geändert haben oder nicht mehr verfügbar sein.',
    'dataArchive.removeError': 'Entfernen fehlgeschlagen',
    'dataArchive.contentNotFound': 'Kein archivierter Inhalt vorhanden.',

    // Lesezeichen Formular
    rating: "Bewertung",
    category: "Kategorie",
    noRating: "Keine Bewertung",
    createCategory: "Erstellen",
    hideInput: "Eingabe ausblenden",
    newCategoryTitle: "Neue Kategorie erstellen",
    newCategoryPlaceholder: "Neue Kategorie eingeben...",

    // Lesezeichen Kategorien (Auto-Erkennung)
    'categories.work': 'Arbeit',
    'categories.dev': 'Dev',
    'categories.ai': 'KI',
    'categories.design': 'Design',
    'categories.tools': 'Tools',
    'categories.news': 'News',
    'categories.shopping': 'Shopping',
    'categories.deals': 'Angebote',
    'categories.finance': 'Finanzen',
    'categories.food': 'Essen',
    'categories.travel': 'Reisen',
    'categories.fitness': 'Fitness',
    'categories.entertainment': 'Unterhaltung',
    'categories.gaming': 'Gaming',
    'categories.diy': 'DIY',
    'categories.inbox': 'Später',
    'categories.important': 'Wichtig',
    'categories.random': 'Sonstiges',
    'categories.other': 'Andere',

    // Kategorieverwaltung
    'categories.title': 'Kategorien',
    'categories.placeholder': 'Neue Kategorie...',
    'categories.add': 'Kategorie hinzufügen',
    'categories.empty': 'Noch keine Kategorien',
    'categories.emptyHint': 'Tippe oben einen Namen ein und tippe auf + um deine erste Kategorie anzulegen!',
    'categories.emptyError': 'Kategoriename darf nicht leer sein',
    'categories.existsError': 'Kategorie existiert bereits',
    'categories.deleteConfirm': 'Kategorie "{name}" wirklich löschen? (Lesezeichen bleiben erhalten)',
    'categories.searchPlaceholder': 'Suchen oder neue Kategorie eingeben...',
    'categories.noResults': 'Keine Kategorien gefunden',
    'categories.noResultsHint': 'Tippe oben auf + um sie als neue Kategorie anzulegen'
  },
  fr: {
    // Header
    appName: "MyBoki.Me",
    appTitle: "📚 myboki.me",
    appSubtitle: "",

    // Tab Navigation
    tabBookmarks: "Signets",
    tabGroups: "Groupes",
    tabReminders: "Rappels",

    // Main buttons
    addNewBookmark: "➕ Nouveau signet",
    
    // Form labels and buttons
    editBookmark: "Modifier le signet",
    addBookmark: "Ajouter un nouveau signet",
    title: "Titre",
    url: "URL",
    description: "Description",
    titlePlaceholder: "Entrez le titre du signet",
    urlPlaceholder: "Entrez l'URL du site web (ex: google.com)",
    descriptionPlaceholder: "Description optionnelle",
    updateBookmark: "Mettre à jour le signet",
    addBookmarkBtn: "Ajouter le signet",
    cancel: "Annuler",
    saving: "Enregistrement...",
    
    // Bookmark item actions
    visit: "🔗 Visiter",
    open: "Ouvrir",
    edit: "Modifier",
    delete: "Supprimer",
    share: "Partager",
    remindMe: "Me rappeler",

    // Reminder dialog
    createReminder: "Créer un rappel",
    frequency: "Fréquence",
    reminderOnce: "Une fois",
    reminderDaily: "Quotidien",
    reminderWeekly: "Hebdomadaire",
    reminderMonthly: "Mensuel",
    quickReminder: "Rappel rapide",
    in30Min: "Dans 30 min",
    in1Hour: "Dans 1 heure",
    in3Hours: "Dans 3 heures",
    tomorrow: "Demain",
    nextWeek: "Semaine prochaine",
    customDateTime: "Date & heure personnalisées",
    create: "Créer",
    pleaseSelectDateTime: "Veuillez sélectionner la date et l'heure",
    notificationsDenied: "Les notifications push sont bloquées. Veuillez les activer dans les paramètres du navigateur.",
    reminderCreated: "Rappel créé!",

    // Search and sort
    searchBookmarks: "Rechercher... (ex. \"3 étoiles\" ou \"2 étoiles gâteau\")",
    searchPlaceholder: "🔍 Rechercher des signets...",
    sortBy: "Trier par :",
    newest: "Plus récents d'abord",
    oldest: "Plus anciens d'abord",
    titleSort: "Titre A-Z",
    urlSort: "URL A-Z",
    favorites: "Favoris uniquement",
    
    // Favorites
    addToFavorites: "Ajouter aux favoris",
    removeFromFavorites: "Retirer des favoris",
    showFavorites: "Afficher les favoris",
    showAll: "Afficher tout",
    
    // Empty state
    noBookmarks: "Aucun signet encore !",
    noBookmarksDesc: "Ajoutez votre premier signet pour commencer.",
    noResults: "Aucun signet trouvé pour",
    noResultsFound: "Aucun résultat trouvé",
    tryDifferentSearch: "Essayez un autre terme de recherche",

    // Bookmark details
    fullUrl: "URL complète :",
    created: "Créé :",
    updated: "Mis à jour :",
    
    // Footer
    totalBookmarks: "Total des signets :",
    
    // Pagination
    showing: "Affichage",
    of: "de",
    bookmarks: "signets",
    previous: "Précédent",
    next: "Suivant",
    
    // Validation messages
    titleRequired: "Le titre est requis",
    urlRequired: "L'URL est requise",
    invalidUrl: "Veuillez entrer une URL valide",
    
    // Confirmation
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer ce signet ?",
    logoutConfirm: "Êtes-vous sûr de vouloir vous déconnecter ?",
    
    // Authentication
    login: "Connexion",
    register: "S'inscrire",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    confirmPassword: "Confirmer le mot de passe",
    emailPlaceholder: "Entrez votre adresse email",
    passwordPlaceholder: "Entrez votre mot de passe",
    namePlaceholder: "Entrez votre nom complet",
    confirmPasswordPlaceholder: "Confirmez votre mot de passe",
    loginBtn: "Se connecter",
    registerBtn: "Créer un compte",
    loading: "Chargement...",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    registerLink: "S'inscrire",
    loginLink: "Se connecter",
    welcomeBack: "Bon retour",
    loggedInAs: "Connecté en tant que",
    
    // Validation messages
    emailRequired: "L'email est requis",
    passwordRequired: "Le mot de passe est requis",
    nameRequired: "Le nom est requis",
    invalidEmail: "Veuillez entrer une adresse email valide",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    
    goOnline: "Passer en ligne",
    goOffline: "Passer hors ligne",
    switchToOnline: "Basculer en mode en ligne",
    switchToOffline: "Basculer en mode hors ligne",

    // Voice Control
    voiceControlTitle: "Contrôle vocal",
    privacyFirst: "Confidentialité d'abord",
    onDeviceProcessing: "Traitement sur l'appareil",
    noDataTransmission: "Aucune transmission de données",
    gdprCompliant: "Conforme RGPD",
    exampleCommands: "Commandes d'exemple",
    activateVoiceControl: "Activer le contrôle vocal",
    continueWithoutVoice: "Continuer sans voix",
    loadingModel: "Chargement du modèle vocal...",
    listening: "À l'écoute...",
    commandNotRecognized: "Commande non reconnue",
    commandRecognized: "Commande reconnue",
    stopListening: "Arrêter l'écoute",
    startListening: "Démarrer la saisie vocale",
    showVoiceHelp: "Afficher les commandes vocales",
    revokeVoiceConsent: "Désactiver le contrôle vocal",
    voiceCommands: "Commandes vocales",
    closeHelp: "Fermer l'aide",
    closeError: "Fermer l'erreur",
    voiceTips: "Conseils",
    speakClearly: "Parlez clairement à volume normal",
    waitForBeep: "Attendez l'icône du microphone avant de parler",
    shortCommands: "Utilisez des commandes courtes et claires",
    browserBased: "Basé sur le navigateur",
    instantReady: "Prêt instantanément",
    privacyNote: "Note de confidentialité",
    commandCategoryonline: "Mode en ligne",
    commandCategorysystem: "Système",
    
    // Password Reset
    forgotPasswordTitle: "Mot de passe oublié ?",
    forgotPasswordDescription: "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    emailSentTitle: "Email envoyé",
    emailSentMessage: "Si l'adresse email existe dans notre système, vous recevrez un lien de réinitialisation sous peu.",
    checkEmailInstruction: "Veuillez vérifier votre boîte email et suivre les instructions dans l'email.",
    backToLogin: "Retour à la connexion",
    sendResetLink: "Envoyer le lien de réinitialisation",
    sendingResetLink: "Envoi en cours...",
    resetPasswordTitle: "Réinitialiser le mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    newPasswordPlaceholder: "Entrez le nouveau mot de passe",
    confirmNewPasswordPlaceholder: "Confirmez le nouveau mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    updatingPassword: "Mise à jour...",
    passwordUpdatedTitle: "Mot de passe mis à jour",
    passwordUpdatedMessage: "Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    proceedToLogin: "Continuer vers la connexion",
    invalidResetToken: "Token de réinitialisation invalide ou expiré",
    passwordResetError: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    sessionExpiredSecurity: "Vous avez été déconnecté pour des raisons de sécurité car votre session a expiré.",
    offlineTimeout: "Vous êtes resté hors ligne trop longtemps. Veuillez vous reconnecter.",
    offlineBanner: "Vous êtes hors ligne. Les modifications seront synchronisées une fois la connexion rétablie.",
    back: "Retour",
    
    // HamburgerMenu
    categories: "Catégories",
    voiceControl: "Commandes vocales",
    startVoiceInput: "Activer la saisie vocale",
    stopVoiceInput: "Arrêter la saisie vocale",
    themes: "Thèmes",
    selectTheme: "Thèmes",
    privacy: "Confidentialité",
    settings: "Paramètres",
    support: "Support",
    'version.title': 'Version',
    'version.current': 'Version actuellement installée',
    'version.upToDate': 'Vous utilisez la version la plus récente.',
    language: "Langue",
    upgradeBeta: "Essayer la Bêta",

    // Settings
    'settings.notifications': 'Notifications',
    'settings.pushNotifications': 'Activer les notifications push',
    'settings.dataBackup': 'Sauvegarde des données',
    'settings.autoBackup': 'Sauvegarde automatique',
    'settings.general': 'Général',
    'settings.language': 'Langue',
    'settings.selectLanguage': 'Choisir la langue',
    'settings.voiceControl': 'Contrôle vocal',
    'settings.voiceActivate': 'Activer les commandes vocales',
    'settings.voicePrivacyRevoke': 'Révoquer le consentement vocal',
    'settings.save': 'Sauvegarder',
    'settings.saved': 'Paramètres sauvegardés !',

    // Menu
    'menu.bookmarks': 'Signets',
    'menu.profile': 'Profil',
    'menu.version': 'Version',
    'menu.todo': 'À faire',
    'menu.allBookmarks': 'Aperçu',
    'menu.reminders': 'Rappels',
    'menu.calendar': 'Calendrier',

    // Paramètres de navigation
    'settings.navigation': 'Navigation',
    'settings.navDescription': 'Choisissez jusqu\'à 3 éléments pour la barre de navigation.',
    'settings.navMaxThree': 'Maximum 3 éléments peuvent être sélectionnés',
    'settings.navMinOne': 'Au moins 1 élément doit être sélectionné',
    'settings.navMoveUp': 'Monter',
    'settings.navMoveDown': 'Descendre',

    // Paramètres du profil
    'settings.profile': 'Profil',
    'settings.profileDescription': 'Gérez votre adresse e-mail, votre mot de passe et votre compte.',
    'settings.currentEmail': 'Adresse e-mail',
    'settings.newEmail': 'Nouvelle adresse e-mail',
    'settings.changeEmail': "Changer l'adresse e-mail",
    'settings.applyChange': 'Modifier',
    'settings.emailChanged': 'Adresse e-mail modifiée avec succès.',
    'settings.emailChangeError': "Erreur lors de la modification de l'adresse e-mail. Veuillez réessayer.",
    'settings.currentPassword': 'Mot de passe actuel',
    'settings.newPassword': 'Nouveau mot de passe',
    'settings.confirmNewPassword': 'Confirmer le nouveau mot de passe',
    'settings.changePasswordBtn': 'Changer le mot de passe',
    'settings.passwordChanged': 'Mot de passe modifié avec succès.',
    'settings.passwordChangeError': 'Erreur lors de la modification du mot de passe. Veuillez vérifier votre mot de passe actuel.',
    'settings.deleteAccountTitle': 'Supprimer le compte',
    'settings.deleteAccountWarning': 'Supprime définitivement toutes vos données (signets, listes de courses, recettes, rappels, liens partagés). Action irréversible.',
    'settings.deleteAccountPasswordLabel': 'Confirmer avec votre mot de passe',
    'settings.deleteAccountButton': '🗑️ Supprimer définitivement',
    'settings.deleteAccountConfirm': 'Voulez-vous vraiment supprimer définitivement votre compte ? Toutes vos données seront irrévocablement supprimées. Cette action est irréversible.',
    'settings.accountDeleted': 'Votre compte a été supprimé avec succès.',
    'settings.accountDeleteError': 'Erreur lors de la suppression du compte. Veuillez réessayer ou contacter le support.',
    'settings.passwordRequiredForAction': 'Veuillez saisir votre mot de passe pour confirmer.',
    'settings.confirmWithPassword': 'Confirmez la modification avec votre mot de passe',
    'settings.nothingToChange': 'Veuillez saisir une nouvelle adresse e-mail et/ou un nouveau mot de passe.',

    'nav.bookmarks': 'Signets',
    'nav.reminders': 'Rappels',
    'nav.quickList': 'Liste de courses',
    'nav.todo': 'À faire',
    'nav.recipes': 'Recettes',

    // Rappels (vue calendrier + dialogue de création)
    'reminders.title': 'Calendrier',
    'reminders.month': 'Mois',
    'reminders.week': 'Semaine',
    'reminders.today': "Aujourd'hui",
    'reminders.previous': 'Précédent',
    'reminders.next': 'Suivant',
    'reminders.viewMode': 'Vue',
    'reminders.noRemindersThisDay': 'Aucun rappel ce jour-là',
    'reminders.deleteConfirm': 'Vraiment supprimer ce rappel ?',
    'reminders.frequencyCustom': 'Personnalisé',
    'reminders.editTitle': 'Modifier le rappel',
    'reminders.titleLabel': 'Titre',
    'reminders.titleRequired': 'Veuillez saisir un titre',
    'reminders.save': 'Enregistrer',
    'reminders.saving': 'Enregistrement...',
    'reminders.saved': 'Rappel mis à jour.',
    'reminders.saveError': "Erreur lors de l'enregistrement.",
    'reminders.close': 'Fermer',
    'reminders.editAction': 'Modifier',
    'reminders.deleteAction': 'Supprimer',
    'reminders.activate': 'Activer',
    'reminders.deactivate': 'Désactiver',
    'reminders.openBookmark': 'Ouvrir le signet',

    // Export/Share functionality
    exportBookmarks: "Exporter les signets",
    exportCompleted: "Exportation terminée!",
    exportSuccessMessage: "Vos signets ont été exportés avec succès. Le fichier a été sauvegardé dans vos téléchargements.",
    shareBookmark: "Partager le signet",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié dans le presse-papier!",
    copyFailed: "Échec de la copie",

    // Options des paramètres
    autoRemoveInvalidLinks: "Supprimer automatiquement les liens invalides",
    autoRemoveInactiveReminders: "Supprimer automatiquement les rappels désactivés",

    // Menu Recettes
    'menu.recipes': 'Recettes',
    'menu.recipesOverview': 'Ma collection',
    'menu.shoppingList': 'Courses',
    'menu.quickList': 'Courses du jour',
    'menu.archive': 'Archive de recettes',
    'menu.dataArchive': 'Archive',

    // Liste de courses rapide
    'quickList.title': 'Achats du jour',
    'quickList.addItem': 'Ajouter un article',
    'quickList.progress': '{completed} sur {total} terminé',
    'quickList.error': 'Erreur lors du chargement',
    'quickList.addError': 'Erreur lors de l\'ajout',
    'quickList.placeholder': 'Ajouter un article...',
    'quickList.empty': 'Pas encore d\'articles',
    'quickList.emptyHint': 'Ajoutez votre premier article!',
    'quickTodo.error': 'Erreur lors du chargement de la liste de tâches',
    'quickTodo.duplicateItem': 'La tâche existe déjà dans la liste',
    'quickTodo.addError': 'Erreur lors de l\'ajout',
    'quickTodo.removeError': 'Erreur lors de la suppression',
    'quickTodo.progress': '{completed} sur {total} terminé',
    'quickTodo.placeholder': 'Ajouter une tâche...',
    'quickTodo.sharedList': 'Liste de tâches partagée',
    'quickTodo.privateList': 'Liste de tâches privée',
    'quickTodo.activelyShared': '(Partagée activement)',
    'quickTodo.primaryList': '(Liste principale)',
    'quickTodo.private': '(Privée)',
    'quickTodo.refresh': 'Actualiser',
    'quickTodo.switchList': 'Gérer les listes',
    'quickTodo.switchListTitle': 'Choisir une liste de tâches',
    'quickTodo.noOtherLists': 'Aucune autre liste disponible',
    'quickTodo.newList': 'Créer une nouvelle liste',
    'quickTodo.slotPrimary': 'Liste principale',
    'quickTodo.slotSecondary': 'Deuxième liste',
    'quickTodo.confirmDeleteList': 'Supprimer définitivement cette liste ?',
    'quickTodo.deleteListError': 'Erreur lors de la suppression de la liste',
    'quickTodo.empty': 'Pas encore de tâches',
    'quickTodo.emptyHint': 'Ajoutez votre première tâche !',
    'quickTodo.addSecondary': 'Deuxième liste de tâches',
    'quickTodo.removeSecondary': 'Supprimer la deuxième liste',
    'quickTodo.addSecondaryError': 'Erreur lors de la création de la deuxième liste',
    'quickList.viewAll': 'Toutes les listes',
    'quickList.refresh': 'Actualiser',
    'quickList.switchList': 'Gérer les listes',
    'quickList.switchListTitle': 'Choisir une liste de courses',
    'quickList.noOtherLists': 'Aucune autre liste disponible',
    'quickList.newList': 'Créer une nouvelle liste',
    'quickList.slotPrimary': 'Liste principale',
    'quickList.slotSecondary': 'Deuxième liste',
    'quickList.confirmDeleteList': 'Supprimer définitivement cette liste ?',
    'quickList.deleteListError': 'Erreur lors de la suppression de la liste',
    'quickList.sharedList': 'Liste partagée',
    'quickList.privateList': 'Liste privée',
    'quickList.activelyShared': '(Partagée activement)',
    'quickList.private': '(Privée)',
    'quickList.setAsSecondary': 'Définir comme deuxième liste "Aujourd\'hui"',
    'quickList.removeSecondary': 'Retirer de "Aujourd\'hui"',
    'quickList.primaryList': '(Liste principale)',

    // Partage
    'share.title': 'Partager la liste',
    'share.shareList': 'Partager',
    'share.sharedList': 'Liste partagée',
    'share.linkTab': 'Lien de partage',
    'share.collaboratorsTab': 'Collaborateurs',
    'share.createLink': 'Créer un lien',
    'share.copy': 'Copier',
    'share.copied': 'Copié!',
    'share.shareVia': 'Partager via...',
    'share.expiresIn24h': 'Lien valide 24 heures',
    'share.description': 'Créez un lien et partagez-le. Toute personne avec le lien peut modifier la liste.',
    'share.activeShares': 'Liens actifs',
    'share.uses': 'utilisations',
    'share.revoke': 'Révoquer',
    'share.noCollaborators': 'Pas encore de collaborateurs',
    'share.removeCollaborator': 'Supprimer',
    'share.onlyOwnerCanShare': 'Seul le propriétaire peut partager cette liste.',
    'share.error': 'Erreur lors de la création du lien',
    'share.defaultTitle': 'Liste de courses',
    'share.inviteText': 'Rejoins ma liste de courses',
    'share.invalidLink': 'Lien invalide',
    'share.loadError': 'Erreur lors du chargement',
    'share.joinError': 'Erreur lors de la jonction',
    'share.invalidTitle': 'Lien invalide',
    'share.backHome': 'Retour à l\'accueil',
    'share.joinTitle': 'Rejoindre la liste',
    'share.listName': 'Liste',
    'share.owner': 'Créée par',
    'share.items': 'Articles',
    'share.expiresIn': 'Valide encore',
    'share.expired': 'Expiré',
    'share.joinNow': 'Rejoindre',
    'share.loginToJoin': 'Se connecter',
    'share.cancel': 'Annuler',
    'share.loginRequired': 'Vous devez être connecté pour rejoindre la liste.',
    'share.loading': 'Chargement...',
    'share.alreadyMember': 'Vous êtes déjà membre',
    'share.joinSuccess': 'Rejoint avec succès!',
    'share.redirecting': 'Redirection...',

    // Liste des recettes
    'recipes.title': 'Recettes',
    'recipes.searchPlaceholder': 'Rechercher des recettes...',
    'recipes.noRecipes': 'Aucune recette trouvée',
    'recipes.noRecipesHint': 'Les favoris avec des mots-clés comme "recette", "ingrédients" sont automatiquement détectés',
    'recipes.createShoppingList': 'Créer une liste de courses',
    'recipes.viewRecipe': 'Voir la recette',
    'recipes.archive': 'Archiver',
    'recipes.confirmArchive': 'Archiver cette recette?',
    'recipes.archived': 'La recette a été archivée',
    'recipes.listCreated': 'Liste de courses créée!',
    'recipes.addedToCart': 'Ajouté au panier!',
    'recipes.addToShoppingList': 'Ajouter à la liste',
    'recipes.addedToList': 'Ajouté à la liste de courses!',
    'recipes.listAddError': 'Erreur lors de l\'ajout à la liste',
    'recipes.pickShoppingList': 'À quelle liste de courses ajouter ceci ?',
    'recipes.newShoppingList': '+ Créer une nouvelle liste',
    'recipes.newShoppingListPlaceholder': 'Nom de la nouvelle liste (facultatif)',
    'recipes.noIngredients': 'Aucun ingrédient disponible pour cette recette. Veuillez modifier la recette et ajouter des ingrédients.',
    'recipes.extractionInfo': 'Les ingrédients de cette recette n\'ont pas encore été chargés. Cliquez sur le bouton pour charger automatiquement les ingrédients depuis le site web.',
    'recipes.extractIngredients': 'Charger les ingrédients depuis le site',
    'recipes.extracting': 'Chargement des ingrédients...',
    'recipes.extractionError': 'Erreur lors du chargement des ingrédients. Le site web ne prend peut-être pas en charge la détection automatique.',
    'recipes.instagramNotSupported': 'Instagram ne prend pas en charge l\'extraction automatique des recettes. Vous pouvez créer la recette manuellement.',
    'recipes.createManually': 'Créer la recette manuellement',
    'recipes.openInInstagram': 'Ouvrir dans Instagram',
    'recipes.viewOriginal': 'Voir la recette originale',
    'recipes.addToCart': 'Ajouter au panier',
    'recipes.baseServings': 'Portions de base',
    'recipes.targetServings': 'Portions souhaitées',
    'recipes.ingredients': 'Ingrédients',
    'recipes.manualRecipes': 'Mes recettes',
    'recipes.bookmarkRecipes': 'Favoris de recettes',
    'recipes.servings': 'Portions',
    'recipes.quantity': 'Quantité',
    'recipes.unit': 'Unité',
    'recipes.ingredient': 'Ingrédient',
    'recipes.note': 'Remarque',
    'recipes.servingsQuestion': 'Pour combien de personnes souhaitez-vous cuisiner?',
    'recipes.confirm': 'Confirmer',
    'recipes.cancel': 'Annuler',
    'recipes.close': 'Fermer',
    'recipes.print': 'Imprimer',
    'recipes.instructions': 'Préparation',
    'recipes.addStep': 'Ajouter une étape',
    'recipes.removeStep': 'Supprimer l\'étape',
    'recipes.stepPlaceholder': 'Décrivez cette étape de préparation...',
    'recipes.notOnlineRecipeHint': 'Ceci n\'est pas une recette en ligne. Veuillez utiliser le bouton de menu « Voir la recette ».',

    // Formulaire de recette (CRUD)
    'recipes.form.createTitle': 'Créer une nouvelle recette',
    'recipes.form.editTitle': 'Modifier la recette',
    'recipes.form.saveAndClose': 'Enregistrer et fermer',
    'recipes.form.newRecipe': 'Nouvelle recette',
    'recipes.form.title': 'Nom de la recette',
    'recipes.form.titleRequired': 'Le nom de la recette est requis',
    'recipes.form.description': 'Description',
    'recipes.form.baseServings': 'Portions de base',
    'recipes.form.servingsInvalid': 'Au moins 1 portion requise',
    'recipes.form.difficulty': 'Difficulté',
    'recipes.form.prepTime': 'Temps de préparation',
    'recipes.form.cookTime': 'Temps de cuisson',
    'recipes.form.minutes': 'minutes',
    'recipes.form.addIngredient': 'Ajouter un ingrédient',
    'recipes.form.ingredientName': 'Ingrédient',
    'recipes.form.note': 'Note',
    'recipes.form.create': 'Créer la recette',
    'recipes.form.update': 'Mettre à jour la recette',
    'recipes.form.confirmDelete': 'Vraiment supprimer cette recette?',
    'recipes.form.deleteSuccess': 'Recette supprimée',
    'recipes.form.createSuccess': 'Recette créée',
    'recipes.form.updateSuccess': 'Recette mise à jour',
    'recipes.difficulty.easy': 'Facile',
    'recipes.difficulty.medium': 'Moyen',
    'recipes.difficulty.hard': 'Difficile',

    // Liste de courses
    'shoppingList.title': 'Listes de courses',
    'shoppingList.all': 'Toutes',
    'shoppingList.open': 'Ouvertes',
    'shoppingList.completed': 'Terminées',
    'shoppingList.noLists': 'Aucune liste de courses',
    'shoppingList.noListsHint': 'Créer une liste de courses à partir d\'une recette',
    'shoppingList.items': 'articles',
    'shoppingList.created': 'Créé',
    'shoppingList.selectList': 'Sélectionner une liste de courses',
    'shoppingList.confirmDelete': 'Supprimer cette liste de courses?',
    'shoppingList.edit': 'Modifier',
    'shoppingList.save': 'Enregistrer',
    'shoppingList.cancel': 'Annuler',
    'shoppingList.addItem': 'Ajouter un article',
    'shoppingList.newItemPlaceholder': 'p.ex. Tomates',
    'shoppingList.empty': 'Aucune liste de courses',
    'shoppingList.backToList': 'Retour à l\'aperçu',
    'shoppingList.more': 'autres',
    'shoppingList.editMode': 'Modifier la liste de courses',
    'shoppingList.newList': '+ Nouvelle liste de courses',
    'shoppingList.manualTitle': 'Nouvelle liste de courses',
    'shoppingList.name': 'Nom',
    'shoppingList.namePlaceholder': 'p.ex. Courses hebdomadaires, Quincaillerie, Fête samedi',
    'shoppingList.description': 'Description (optionnel)',
    'shoppingList.descriptionPlaceholder': 'Notes pour la liste de courses...',
    'shoppingList.create': 'Créer',
    'shoppingList.nameRequired': 'Veuillez saisir un nom',
    'shoppingList.itemName': 'Article',
    'shoppingList.itemQuantity': 'Quantité',
    'shoppingList.itemUnit': 'Unité',
    'shoppingList.searchPlaceholder': 'Rechercher des listes...',
    'shoppingList.noResults': 'Aucune liste trouvée',
    'shoppingList.enterListName': 'Entrer le nom de la liste...',
    'shoppingList.addDescription': 'Ajouter une description',
    'shoppingList.confirmName': 'Confirmer le nom',
    'shoppingList.addItemPlaceholder': 'Ajouter un article...',

    // Archive
    'archive.title': 'Archive des recettes',
    'archive.info': 'L\'archive stocke les recettes en tant que snapshots au cas où l\'URL d\'origine disparaîtrait ou qu\'un job de nettoyage supprimerait les favoris invalides.',
    'archive.noArchived': 'Aucune recette archivée',
    'archive.noArchivedHint': 'Archiver des recettes pour en conserver une copie permanente',
    'archive.open': 'Ouvrir',
    'archive.archivedOn': 'Archivé le',
    'archive.originalUrl': 'URL d\'origine',
    'archive.category': 'Catégorie',

    // Archive de données (corbeille / restauration pour catégories, favoris, recettes, listes de courses)
    'dataArchive.title': 'Archive',
    'dataArchive.intro': 'Les catégories, favoris, recettes et listes de courses supprimés atterrissent ici automatiquement et peuvent être restaurés depuis cet endroit.',
    'dataArchive.filterAll': 'Tous',
    'dataArchive.empty': 'Aucun élément archivé',
    'dataArchive.emptyHint': 'Les catégories, favoris, recettes et listes de courses supprimés apparaîtront ici.',
    'dataArchive.badgeDeleted': 'Supprimé',
    'dataArchive.badgeSnapshot': 'Sauvegarde automatique',
    'dataArchive.restore': 'Restaurer',
    'dataArchive.restoreSuccess': 'Restauré avec succès',
    'dataArchive.restoreError': 'Échec de la restauration',
    'dataArchive.restoreExists': 'Existe déjà, non restauré',
    'dataArchive.removeConfirm': 'Supprimer définitivement cette entrée de l\'archive ? (Action irréversible)',
    'dataArchive.removePermanently': 'Supprimer définitivement',
    'dataArchive.noTitle': '(sans titre)',
    'dataArchive.viewContent': 'Voir le contenu',
    'dataArchive.source': 'Source',
    'dataArchive.author': 'Auteur',
    'dataArchive.archivedNotice': 'Version archivée du {date} – original disponible via le lien ci-dessus. Le contenu peut avoir changé ou ne plus être disponible.',
    'dataArchive.removeError': 'Échec de la suppression',
    'dataArchive.contentNotFound': 'Aucun contenu archivé disponible.',
    'archive.snapshot': 'Snapshot',

    // Formulaire de signet
    rating: "Évaluation",
    category: "Catégorie",
    noRating: "Aucune évaluation",
    createCategory: "Créer",
    hideInput: "Masquer le champ",
    newCategoryTitle: "Créer une nouvelle catégorie",
    newCategoryPlaceholder: "Entrer une nouvelle catégorie...",

    // Catégories de signets (détection auto)
    'categories.work': 'Travail',
    'categories.dev': 'Dev',
    'categories.ai': 'IA',
    'categories.design': 'Design',
    'categories.tools': 'Outils',
    'categories.news': 'Actualités',
    'categories.shopping': 'Shopping',
    'categories.deals': 'Promos',
    'categories.finance': 'Finances',
    'categories.food': 'Cuisine',
    'categories.travel': 'Voyages',
    'categories.fitness': 'Fitness',
    'categories.entertainment': 'Divertissement',
    'categories.gaming': 'Jeux',
    'categories.diy': 'Bricolage',
    'categories.inbox': 'Plus tard',
    'categories.important': 'Important',
    'categories.random': 'Divers',
    'categories.other': 'Autres',

    // Gestion des catégories
    'categories.title': 'Catégories',
    'categories.placeholder': 'Nouvelle catégorie...',
    'categories.add': 'Ajouter une catégorie',
    'categories.empty': 'Pas encore de catégories',
    'categories.emptyHint': 'Tapez un nom ci-dessus et appuyez sur + pour créer votre première catégorie !',
    'categories.emptyError': 'Le nom de la catégorie ne peut pas être vide',
    'categories.existsError': 'La catégorie existe déjà',
    'categories.deleteConfirm': 'Supprimer la catégorie "{name}"? (Les signets seront conservés)',
    'categories.searchPlaceholder': 'Rechercher ou saisir une nouvelle catégorie...',
    'categories.noResults': 'Aucune catégorie trouvée',
    'categories.noResultsHint': 'Appuyez sur + ci-dessus pour l\'ajouter comme nouvelle catégorie'
  },
  es: {
    // Header
    appName: "MyBoki.Me",
    appTitle: "📚 myboki.me",
    appSubtitle: "",

    // Tab Navigation
    tabBookmarks: "Marcadores",
    tabGroups: "Grupos",
    tabReminders: "Recordatorios",

    // Main buttons
    addNewBookmark: "➕ Nuevo marcador",
    
    // Form labels and buttons
    editBookmark: "Editar marcador",
    addBookmark: "Agregar nuevo marcador",
    title: "Título",
    url: "URL",
    description: "Descripción",
    titlePlaceholder: "Ingrese el título del marcador",
    urlPlaceholder: "Ingrese la URL del sitio web (ej: google.com)",
    descriptionPlaceholder: "Descripción opcional",
    updateBookmark: "Actualizar marcador",
    addBookmarkBtn: "Agregar marcador",
    cancel: "Cancelar",
    saving: "Guardando...",
    
    // Bookmark item actions
    visit: "🔗 Visitar",
    open: "Abrir",
    edit: "Editar",
    delete: "Eliminar",
    share: "Compartir",
    remindMe: "Recordarme",

    // Reminder dialog
    createReminder: "Crear recordatorio",
    frequency: "Frecuencia",
    reminderOnce: "Una vez",
    reminderDaily: "Diario",
    reminderWeekly: "Semanal",
    reminderMonthly: "Mensual",
    quickReminder: "Recordatorio rápido",
    in30Min: "En 30 min",
    in1Hour: "En 1 hora",
    in3Hours: "En 3 horas",
    tomorrow: "Mañana",
    nextWeek: "Próxima semana",
    customDateTime: "Fecha y hora personalizadas",
    create: "Crear",
    pleaseSelectDateTime: "Por favor seleccione fecha y hora",
    notificationsDenied: "Las notificaciones push están bloqueadas. Por favor actívalas en la configuración del navegador.",
    reminderCreated: "¡Recordatorio creado!",

    // Search and sort
    searchBookmarks: "Buscar... (ej. \"3 estrellas\" o \"2 estrellas pastel\")",
    searchPlaceholder: "🔍 Buscar marcadores...",
    sortBy: "Ordenar por:",
    newest: "Más recientes primero",
    oldest: "Más antiguos primero",
    titleSort: "Título A-Z",
    urlSort: "URL A-Z",
    favorites: "Solo favoritos",
    
    // Favorites
    addToFavorites: "Agregar a favoritos",
    removeFromFavorites: "Quitar de favoritos",
    showFavorites: "Mostrar favoritos",
    showAll: "Mostrar todos",
    
    // Empty state
    noBookmarks: "¡Aún no hay marcadores!",
    noBookmarksDesc: "Agrega tu primer marcador para comenzar.",
    noResults: "No se encontraron marcadores para",
    noResultsFound: "No se encontraron resultados",
    tryDifferentSearch: "Prueba con otro término de búsqueda",

    // Bookmark details
    fullUrl: "URL completa:",
    created: "Creado:",
    updated: "Actualizado:",
    
    // Footer
    totalBookmarks: "Total de marcadores:",
    
    // Pagination
    showing: "Mostrando",
    of: "de",
    bookmarks: "marcadores",
    previous: "Anterior",
    next: "Siguiente",
    
    // Validation messages
    titleRequired: "El título es requerido",
    urlRequired: "La URL es requerida",
    invalidUrl: "Por favor ingrese una URL válida",
    
    // Confirmation
    deleteConfirm: "¿Estás seguro de que quieres eliminar este marcador?",
    logoutConfirm: "¿Estás seguro de que quieres cerrar sesión?",
    
    // Authentication
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    confirmPassword: "Confirmar contraseña",
    emailPlaceholder: "Ingrese su dirección de correo electrónico",
    passwordPlaceholder: "Ingrese su contraseña",
    namePlaceholder: "Ingrese su nombre completo",
    confirmPasswordPlaceholder: "Confirme su contraseña",
    loginBtn: "Iniciar sesión",
    registerBtn: "Crear cuenta",
    loading: "Cargando...",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount: "¿No tienes una cuenta?",
    hasAccount: "¿Ya tienes una cuenta?",
    registerLink: "Registrarse",
    loginLink: "Iniciar sesión",
    welcomeBack: "Bienvenido de vuelta",
    loggedInAs: "Conectado como",
    
    // Validation messages
    emailRequired: "El correo electrónico es requerido",
    passwordRequired: "La contraseña es requerida",
    nameRequired: "El nombre es requerido",
    invalidEmail: "Por favor ingrese una dirección de correo electrónico válida",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    
    goOnline: "Conectar",
    goOffline: "Desconectar",
    switchToOnline: "Cambiar a modo en línea",
    switchToOffline: "Cambiar a modo sin conexión",

    // Voice Control
    voiceControlTitle: "Control por voz",
    privacyFirst: "Privacidad primero",
    onDeviceProcessing: "Procesamiento en el dispositivo",
    noDataTransmission: "Sin transmisión de datos",
    gdprCompliant: "Cumple con GDPR",
    exampleCommands: "Comandos de ejemplo",
    activateVoiceControl: "Activar control por voz",
    continueWithoutVoice: "Continuar sin voz",
    loadingModel: "Cargando modelo de voz...",
    listening: "Escuchando...",
    commandNotRecognized: "Comando no reconocido",
    commandRecognized: "Comando reconocido",
    stopListening: "Detener escucha",
    startListening: "Iniciar entrada de voz",
    showVoiceHelp: "Mostrar comandos de voz",
    revokeVoiceConsent: "Desactivar control por voz",
    voiceCommands: "Comandos de voz",
    closeHelp: "Cerrar ayuda",
    closeError: "Cerrar error",
    voiceTips: "Consejos",
    speakClearly: "Hable claramente a volumen normal",
    waitForBeep: "Espere el ícono del micrófono antes de hablar",
    shortCommands: "Use comandos cortos y claros",
    browserBased: "Basado en navegador",
    instantReady: "Listo al instante",
    privacyNote: "Nota de privacidad",
    commandCategoryonline: "Modo en línea",
    commandCategorysystem: "Sistema",
    
    // Password Reset
    forgotPasswordTitle: "¿Olvidaste tu contraseña?",
    forgotPasswordDescription: "Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
    emailSentTitle: "Correo enviado",
    emailSentMessage: "Si la dirección de correo electrónico existe en nuestro sistema, recibirás un enlace de restablecimiento en breve.",
    checkEmailInstruction: "Por favor verifica tu bandeja de entrada y sigue las instrucciones en el correo electrónico.",
    backToLogin: "Volver al inicio de sesión",
    sendResetLink: "Enviar enlace de restablecimiento",
    sendingResetLink: "Enviando...",
    resetPasswordTitle: "Restablecer contraseña",
    newPassword: "Nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    newPasswordPlaceholder: "Ingrese la nueva contraseña",
    confirmNewPasswordPlaceholder: "Confirme la nueva contraseña",
    updatePassword: "Actualizar contraseña",
    updatingPassword: "Actualizando...",
    passwordUpdatedTitle: "Contraseña actualizada",
    passwordUpdatedMessage: "Tu contraseña ha sido actualizada exitosamente. Ahora puedes iniciar sesión con tu nueva contraseña.",
    proceedToLogin: "Continuar al inicio de sesión",
    invalidResetToken: "Token de restablecimiento inválido o expirado",
    passwordResetError: "Ocurrió un error. Por favor intenta de nuevo más tarde.",
    sessionExpiredSecurity: "Ha sido desconectado por razones de seguridad porque su sesión ha expirado.",
    offlineTimeout: "Has estado desconectado demasiado tiempo. Por favor, inicia sesión de nuevo.",
    offlineBanner: "Estás sin conexión. Los cambios se sincronizarán cuando se restablezca la conexión.",
    back: "Atrás",
    
    // HamburgerMenu
    categories: "Categorías",
    voiceControl: "Comandos de voz",
    startVoiceInput: "Activar entrada de voz",
    stopVoiceInput: "Detener entrada de voz",
    themes: "Temas",
    selectTheme: "Temas",
    privacy: "Privacidad",
    settings: "Configuración",
    support: "Soporte",
    'version.title': 'Versión',
    'version.current': 'Versión instalada actualmente',
    'version.upToDate': 'Estás usando la versión más reciente.',
    language: "Idioma",
    upgradeBeta: "Probar Beta",

    // Settings
    'settings.notifications': 'Notificaciones',
    'settings.pushNotifications': 'Activar notificaciones push',
    'settings.dataBackup': 'Copia de seguridad',
    'settings.autoBackup': 'Copia de seguridad automática',
    'settings.general': 'General',
    'settings.language': 'Idioma',
    'settings.selectLanguage': 'Seleccionar idioma',
    'settings.voiceControl': 'Control por voz',
    'settings.voiceActivate': 'Activar comandos de voz',
    'settings.voicePrivacyRevoke': 'Revocar consentimiento de voz',
    'settings.save': 'Guardar',
    'settings.saved': '¡Configuración guardada!',

    // Menu
    'menu.bookmarks': 'Marcadores',
    'menu.profile': 'Perfil',
    'menu.version': 'Versión',
    'menu.todo': 'Tareas',
    'menu.allBookmarks': 'Vista general',
    'menu.reminders': 'Recordatorios',
    'menu.calendar': 'Calendario',

    // Configuración de navegación
    'settings.navigation': 'Navegación',
    'settings.navDescription': 'Elige hasta 3 elementos para la barra de navegación.',
    'settings.navMaxThree': 'Se pueden seleccionar máximo 3 elementos',
    'settings.navMinOne': 'Debe seleccionarse al menos 1 elemento',
    'settings.navMoveUp': 'Subir',
    'settings.navMoveDown': 'Bajar',

    // Configuración del perfil
    'settings.profile': 'Perfil',
    'settings.profileDescription': 'Administra tu dirección de correo electrónico, tu contraseña y tu cuenta.',
    'settings.currentEmail': 'Correo electrónico',
    'settings.newEmail': 'Nuevo correo electrónico',
    'settings.changeEmail': 'Cambiar correo electrónico',
    'settings.applyChange': 'Cambiar',
    'settings.emailChanged': 'Correo electrónico cambiado con éxito.',
    'settings.emailChangeError': 'Error al cambiar el correo electrónico. Inténtalo de nuevo.',
    'settings.currentPassword': 'Contraseña actual',
    'settings.newPassword': 'Nueva contraseña',
    'settings.confirmNewPassword': 'Confirmar nueva contraseña',
    'settings.changePasswordBtn': 'Cambiar contraseña',
    'settings.passwordChanged': 'Contraseña cambiada con éxito.',
    'settings.passwordChangeError': 'Error al cambiar la contraseña. Comprueba tu contraseña actual.',
    'settings.deleteAccountTitle': 'Eliminar cuenta',
    'settings.deleteAccountWarning': 'Elimina permanentemente todos tus datos (marcadores, listas de compras, recetas, recordatorios, enlaces compartidos). No se puede deshacer.',
    'settings.deleteAccountPasswordLabel': 'Confirmar con tu contraseña',
    'settings.deleteAccountButton': '🗑️ Eliminar definitivamente',
    'settings.deleteAccountConfirm': '¿Seguro que quieres eliminar definitivamente tu cuenta? Todos tus datos se eliminarán de forma irrevocable. Esta acción no se puede deshacer.',
    'settings.accountDeleted': 'Tu cuenta ha sido eliminada con éxito.',
    'settings.accountDeleteError': 'Error al eliminar la cuenta. Inténtalo de nuevo o contacta con soporte.',
    'settings.passwordRequiredForAction': 'Introduce tu contraseña para confirmar.',
    'settings.confirmWithPassword': 'Confirme el cambio con su contraseña',
    'settings.nothingToChange': 'Introduzca una nueva dirección de correo electrónico y/o una nueva contraseña.',

    'nav.bookmarks': 'Marcadores',
    'nav.reminders': 'Recordatorios',
    'nav.quickList': 'Lista de compras',
    'nav.todo': 'Tareas',
    'nav.recipes': 'Recetas',

    // Recordatorios (vista de calendario + diálogo de creación)
    'reminders.title': 'Calendario',
    'reminders.month': 'Mes',
    'reminders.week': 'Semana',
    'reminders.today': 'Hoy',
    'reminders.previous': 'Anterior',
    'reminders.next': 'Siguiente',
    'reminders.viewMode': 'Vista',
    'reminders.noRemindersThisDay': 'Sin recordatorios este día',
    'reminders.deleteConfirm': '¿Eliminar este recordatorio?',
    'reminders.frequencyCustom': 'Personalizado',
    'reminders.editTitle': 'Editar recordatorio',
    'reminders.titleLabel': 'Título',
    'reminders.titleRequired': 'Introduce un título',
    'reminders.save': 'Guardar',
    'reminders.saving': 'Guardando...',
    'reminders.saved': 'Recordatorio actualizado.',
    'reminders.saveError': 'Error al guardar.',
    'reminders.close': 'Cerrar',
    'reminders.editAction': 'Editar',
    'reminders.deleteAction': 'Eliminar',
    'reminders.activate': 'Activar',
    'reminders.deactivate': 'Desactivar',
    'reminders.openBookmark': 'Abrir marcador',

    // Export/Share functionality
    exportBookmarks: "Exportar marcadores",
    exportCompleted: "Exportación completada!",
    exportSuccessMessage: "Tus marcadores han sido exportados exitosamente. El archivo ha sido guardado en tu carpeta de descargas.",
    shareBookmark: "Compartir marcador",
    copyLink: "Copiar enlace",
    linkCopied: "Enlace copiado al portapapeles!",
    copyFailed: "Error al copiar",

    // Opciones de configuración
    autoRemoveInvalidLinks: "Eliminar automáticamente enlaces inválidos",
    autoRemoveInactiveReminders: "Eliminar automáticamente recordatorios desactivados",

    // Menú Recetas
    'menu.recipes': 'Recetas',
    'menu.recipesOverview': 'Mi colección',
    'menu.shoppingList': 'Compras',
    'menu.quickList': 'Compras de hoy',
    'menu.archive': 'Archivo de recetas',
    'menu.dataArchive': 'Archivo',

    // Lista de compras rápida
    'quickList.title': 'Compras de hoy',
    'quickList.addItem': 'Añadir artículo',
    'quickList.progress': '{completed} de {total} completado',
    'quickList.error': 'Error al cargar la lista',
    'quickList.addError': 'Error al añadir',
    'quickList.placeholder': 'Añadir artículo...',
    'quickList.empty': 'Sin artículos todavía',
    'quickList.emptyHint': '¡Añade tu primer artículo!',
    'quickTodo.error': 'Error al cargar la lista de tareas',
    'quickTodo.duplicateItem': 'La tarea ya existe en la lista',
    'quickTodo.addError': 'Error al añadir',
    'quickTodo.removeError': 'Error al eliminar',
    'quickTodo.progress': '{completed} de {total} completado',
    'quickTodo.placeholder': 'Añadir tarea...',
    'quickTodo.sharedList': 'Lista de tareas compartida',
    'quickTodo.privateList': 'Lista de tareas privada',
    'quickTodo.activelyShared': '(Compartida activamente)',
    'quickTodo.primaryList': '(Lista principal)',
    'quickTodo.private': '(Privada)',
    'quickTodo.refresh': 'Actualizar',
    'quickTodo.switchList': 'Gestionar listas',
    'quickTodo.switchListTitle': 'Elegir lista de tareas',
    'quickTodo.noOtherLists': 'No hay más listas disponibles',
    'quickTodo.newList': 'Crear nueva lista',
    'quickTodo.slotPrimary': 'Lista principal',
    'quickTodo.slotSecondary': 'Segunda lista',
    'quickTodo.confirmDeleteList': '¿Eliminar esta lista definitivamente?',
    'quickTodo.deleteListError': 'Error al eliminar la lista',
    'quickTodo.empty': 'Sin tareas todavía',
    'quickTodo.emptyHint': '¡Añade tu primera tarea!',
    'quickTodo.addSecondary': 'Segunda lista de tareas',
    'quickTodo.removeSecondary': 'Quitar segunda lista',
    'quickTodo.addSecondaryError': 'Error al crear la segunda lista',
    'quickList.viewAll': 'Todas las listas',
    'quickList.refresh': 'Actualizar',
    'quickList.switchList': 'Gestionar listas',
    'quickList.switchListTitle': 'Elegir lista de compras',
    'quickList.noOtherLists': 'No hay más listas disponibles',
    'quickList.newList': 'Crear nueva lista',
    'quickList.slotPrimary': 'Lista principal',
    'quickList.slotSecondary': 'Segunda lista',
    'quickList.confirmDeleteList': '¿Eliminar esta lista definitivamente?',
    'quickList.deleteListError': 'Error al eliminar la lista',
    'quickList.sharedList': 'Lista compartida',
    'quickList.privateList': 'Lista privada',
    'quickList.activelyShared': '(Compartida activamente)',
    'quickList.private': '(Privada)',
    'quickList.setAsSecondary': 'Establecer como segunda lista "Hoy"',
    'quickList.removeSecondary': 'Eliminar de "Hoy"',
    'quickList.primaryList': '(Lista principal)',

    // Compartir
    'share.title': 'Compartir lista',
    'share.shareList': 'Compartir',
    'share.sharedList': 'Lista compartida',
    'share.linkTab': 'Enlace',
    'share.collaboratorsTab': 'Colaboradores',
    'share.createLink': 'Crear enlace',
    'share.copy': 'Copiar',
    'share.copied': '¡Copiado!',
    'share.shareVia': 'Compartir vía...',
    'share.expiresIn24h': 'Enlace válido 24 horas',
    'share.description': 'Crea un enlace y compártelo. Cualquiera con el enlace puede editar la lista.',
    'share.activeShares': 'Enlaces activos',
    'share.uses': 'usos',
    'share.revoke': 'Revocar',
    'share.noCollaborators': 'Sin colaboradores aún',
    'share.removeCollaborator': 'Eliminar',
    'share.onlyOwnerCanShare': 'Solo el propietario puede compartir esta lista.',
    'share.error': 'Error al crear el enlace',
    'share.defaultTitle': 'Lista de compras',
    'share.inviteText': 'Únete a mi lista de compras',
    'share.invalidLink': 'Enlace inválido',
    'share.loadError': 'Error al cargar',
    'share.joinError': 'Error al unirse',
    'share.invalidTitle': 'Enlace inválido',
    'share.backHome': 'Volver al inicio',
    'share.joinTitle': 'Unirse a la lista',
    'share.listName': 'Lista',
    'share.owner': 'Creada por',
    'share.items': 'Artículos',
    'share.expiresIn': 'Válido aún',
    'share.expired': 'Expirado',
    'share.joinNow': 'Unirse ahora',
    'share.loginToJoin': 'Iniciar sesión',
    'share.cancel': 'Cancelar',
    'share.loginRequired': 'Debes iniciar sesión para unirte a la lista.',
    'share.loading': 'Cargando...',
    'share.alreadyMember': 'Ya eres miembro',
    'share.joinSuccess': '¡Unido con éxito!',
    'share.redirecting': 'Redirigiendo...',

    // Lista de recetas
    'recipes.title': 'Recetas',
    'recipes.searchPlaceholder': 'Buscar recetas...',
    'recipes.noRecipes': 'No se encontraron recetas',
    'recipes.noRecipesHint': 'Los marcadores con palabras clave como "receta", "ingredientes" se detectan automáticamente',
    'recipes.createShoppingList': 'Crear lista de compras',
    'recipes.viewRecipe': 'Ver receta',
    'recipes.archive': 'Archivar',
    'recipes.confirmArchive': '¿Archivar esta receta?',
    'recipes.archived': 'La receta ha sido archivada',
    'recipes.listCreated': '¡Lista de compras creada!',
    'recipes.addedToCart': '¡Añadido al carrito!',
    'recipes.addToShoppingList': 'Añadir a la lista',
    'recipes.addedToList': '¡Añadido a la lista de compras!',
    'recipes.listAddError': 'Error al añadir a la lista',
    'recipes.pickShoppingList': '¿A qué lista de compras quieres añadir esto?',
    'recipes.newShoppingList': '+ Crear nueva lista',
    'recipes.newShoppingListPlaceholder': 'Nombre de la nueva lista (opcional)',
    'recipes.noIngredients': 'No hay ingredientes disponibles para esta receta. Por favor, edita la receta y añade ingredientes.',
    'recipes.extractionInfo': 'Los ingredientes de esta receta aún no se han cargado. Haz clic en el botón para cargar automáticamente los ingredientes desde el sitio web.',
    'recipes.extractIngredients': 'Cargar ingredientes desde el sitio',
    'recipes.extracting': 'Cargando ingredientes...',
    'recipes.extractionError': 'Error al cargar los ingredientes. Es posible que el sitio web no admita la detección automática.',
    'recipes.instagramNotSupported': 'Instagram no admite la extracción automática de recetas. Puedes crear la receta manualmente.',
    'recipes.createManually': 'Crear receta manualmente',
    'recipes.openInInstagram': 'Abrir en Instagram',
    'recipes.viewOriginal': 'Ver receta original',
    'recipes.addToCart': 'Añadir al carrito',
    'recipes.baseServings': 'Porciones base',
    'recipes.targetServings': 'Porciones deseadas',
    'recipes.ingredients': 'Ingredientes',
    'recipes.manualRecipes': 'Mis recetas',
    'recipes.bookmarkRecipes': 'Marcadores de recetas',
    'recipes.servings': 'Porciones',
    'recipes.quantity': 'Cantidad',
    'recipes.unit': 'Unidad',
    'recipes.ingredient': 'Ingrediente',
    'recipes.note': 'Nota',
    'recipes.servingsQuestion': '¿Para cuántas personas quieres cocinar?',
    'recipes.confirm': 'Confirmar',
    'recipes.cancel': 'Cancelar',
    'recipes.close': 'Cerrar',
    'recipes.print': 'Imprimir',
    'recipes.instructions': 'Preparación',
    'recipes.addStep': 'Añadir paso',
    'recipes.removeStep': 'Eliminar paso',
    'recipes.stepPlaceholder': 'Describe este paso de preparación...',
    'recipes.notOnlineRecipeHint': 'Esta no es una receta en línea. Por favor usa el botón de menú "Ver receta".',

    // Formulario de receta (CRUD)
    'recipes.form.createTitle': 'Crear nueva receta',
    'recipes.form.editTitle': 'Editar receta',
    'recipes.form.saveAndClose': 'Guardar y cerrar',
    'recipes.form.newRecipe': 'Nueva receta',
    'recipes.form.title': 'Nombre de la receta',
    'recipes.form.titleRequired': 'El nombre de la receta es obligatorio',
    'recipes.form.description': 'Descripción',
    'recipes.form.baseServings': 'Porciones base',
    'recipes.form.servingsInvalid': 'Se requiere al menos 1 porción',
    'recipes.form.difficulty': 'Dificultad',
    'recipes.form.prepTime': 'Tiempo de preparación',
    'recipes.form.cookTime': 'Tiempo de cocción',
    'recipes.form.minutes': 'minutos',
    'recipes.form.addIngredient': 'Añadir ingrediente',
    'recipes.form.ingredientName': 'Ingrediente',
    'recipes.form.note': 'Nota',
    'recipes.form.create': 'Crear receta',
    'recipes.form.update': 'Actualizar receta',
    'recipes.form.confirmDelete': '¿Realmente eliminar esta receta?',
    'recipes.form.deleteSuccess': 'Receta eliminada',
    'recipes.form.createSuccess': 'Receta creada',
    'recipes.form.updateSuccess': 'Receta actualizada',
    'recipes.difficulty.easy': 'Fácil',
    'recipes.difficulty.medium': 'Medio',
    'recipes.difficulty.hard': 'Difícil',

    // Lista de compras
    'shoppingList.title': 'Listas de compras',
    'shoppingList.all': 'Todas',
    'shoppingList.open': 'Abiertas',
    'shoppingList.completed': 'Completadas',
    'shoppingList.noLists': 'No hay listas de compras',
    'shoppingList.noListsHint': 'Crear una lista de compras desde una receta',
    'shoppingList.items': 'artículos',
    'shoppingList.created': 'Creado',
    'shoppingList.selectList': 'Seleccionar una lista de compras',
    'shoppingList.confirmDelete': '¿Eliminar esta lista de compras?',
    'shoppingList.edit': 'Editar',
    'shoppingList.save': 'Guardar',
    'shoppingList.cancel': 'Cancelar',
    'shoppingList.addItem': 'Añadir artículo',
    'shoppingList.newItemPlaceholder': 'p.ej. Tomates',
    'shoppingList.empty': 'No hay listas de compras',
    'shoppingList.backToList': 'Volver a la vista general',
    'shoppingList.more': 'más',
    'shoppingList.editMode': 'Editar lista de compras',
    'shoppingList.newList': '+ Nueva lista de compras',
    'shoppingList.manualTitle': 'Nueva lista de compras',
    'shoppingList.name': 'Nombre',
    'shoppingList.namePlaceholder': 'p.ej. Compra semanal, Ferretería, Fiesta del sábado',
    'shoppingList.description': 'Descripción (opcional)',
    'shoppingList.descriptionPlaceholder': 'Notas para la lista de compras...',
    'shoppingList.create': 'Crear',
    'shoppingList.nameRequired': 'Por favor ingrese un nombre',
    'shoppingList.itemName': 'Artículo',
    'shoppingList.itemQuantity': 'Cantidad',
    'shoppingList.itemUnit': 'Unidad',
    'shoppingList.searchPlaceholder': 'Buscar listas...',
    'shoppingList.noResults': 'No se encontraron listas',
    'shoppingList.enterListName': 'Ingresar nombre de lista...',
    'shoppingList.addDescription': 'Agregar descripción',
    'shoppingList.confirmName': 'Confirmar nombre',
    'shoppingList.addItemPlaceholder': 'Agregar artículo...',

    // Archivo
    'archive.title': 'Archivo de recetas',
    'archive.info': 'El archivo almacena recetas como snapshots en caso de que la URL original desaparezca o un trabajo de limpieza elimine marcadores no válidos.',
    'archive.noArchived': 'No hay recetas archivadas',
    'archive.noArchivedHint': 'Archivar recetas para mantener una copia permanente',
    'archive.open': 'Abrir',
    'archive.archivedOn': 'Archivado el',
    'archive.originalUrl': 'URL original',

    // Archivo de datos (papelera / restauración para categorías, marcadores, recetas, listas de compra)
    'dataArchive.title': 'Archivo',
    'dataArchive.intro': 'Las categorías, marcadores, recetas y listas de compra eliminados llegan aquí automáticamente y pueden restaurarse desde aquí.',
    'dataArchive.filterAll': 'Todos',
    'dataArchive.empty': 'No hay elementos archivados',
    'dataArchive.emptyHint': 'Las categorías, marcadores, recetas y listas de compra eliminados aparecerán aquí.',
    'dataArchive.badgeDeleted': 'Eliminado',
    'dataArchive.badgeSnapshot': 'Copia de seguridad automática',
    'dataArchive.restore': 'Restaurar',
    'dataArchive.restoreSuccess': 'Restaurado correctamente',
    'dataArchive.restoreError': 'Error al restaurar',
    'dataArchive.restoreExists': 'Ya existe, no restaurado',
    'dataArchive.removeConfirm': '¿Eliminar definitivamente esta entrada del archivo? (No se puede deshacer)',
    'dataArchive.removePermanently': 'Eliminar definitivamente',
    'dataArchive.noTitle': '(sin título)',
    'dataArchive.viewContent': 'Ver contenido',
    'dataArchive.source': 'Fuente',
    'dataArchive.author': 'Autor',
    'dataArchive.archivedNotice': 'Versión archivada del {date} – original disponible en el enlace de arriba. El contenido puede haber cambiado o ya no estar disponible.',
    'dataArchive.removeError': 'Error al eliminar',
    'dataArchive.contentNotFound': 'No hay contenido archivado disponible.',
    'archive.category': 'Categoría',
    'archive.snapshot': 'Snapshot',

    // Formulario de marcador
    rating: "Calificación",
    category: "Categoría",
    noRating: "Sin calificación",
    createCategory: "Crear",
    hideInput: "Ocultar entrada",
    newCategoryTitle: "Crear nueva categoría",
    newCategoryPlaceholder: "Ingresar nueva categoría...",

    // Categorías de marcadores (detección automática)
    'categories.work': 'Trabajo',
    'categories.dev': 'Dev',
    'categories.ai': 'IA',
    'categories.design': 'Diseño',
    'categories.tools': 'Herramientas',
    'categories.news': 'Noticias',
    'categories.shopping': 'Compras',
    'categories.deals': 'Ofertas',
    'categories.finance': 'Finanzas',
    'categories.food': 'Comida',
    'categories.travel': 'Viajes',
    'categories.fitness': 'Fitness',
    'categories.entertainment': 'Entretenimiento',
    'categories.gaming': 'Juegos',
    'categories.diy': 'Bricolaje',
    'categories.inbox': 'Más tarde',
    'categories.important': 'Importante',
    'categories.random': 'Varios',
    'categories.other': 'Otros',

    // Gestión de categorías
    'categories.title': 'Categorías',
    'categories.placeholder': 'Nueva categoría...',
    'categories.add': 'Añadir categoría',
    'categories.empty': 'Sin categorías todavía',
    'categories.emptyHint': '¡Escribe un nombre arriba y toca + para crear tu primera categoría!',
    'categories.emptyError': 'El nombre de la categoría no puede estar vacío',
    'categories.existsError': 'La categoría ya existe',
    'categories.deleteConfirm': '¿Eliminar categoría "{name}"? (Los marcadores se conservarán)',
    'categories.searchPlaceholder': 'Buscar o escribir una nueva categoría...',
    'categories.noResults': 'No se encontraron categorías',
    'categories.noResultsHint': 'Toca + arriba para añadirla como nueva categoría'
  },
  it: {
    // Header
    appName: "MyBoki.Me",
    appTitle: "📚 myboki.me",
    appSubtitle: "",

    // Tab Navigation
    tabBookmarks: "Segnalibri",
    tabGroups: "Gruppi",
    tabReminders: "Promemoria",

    // Main buttons
    addNewBookmark: "➕ Nuovo segnalibro",
    
    // Form labels and buttons
    editBookmark: "Modifica segnalibro",
    addBookmark: "Aggiungi nuovo segnalibro",
    title: "Titolo",
    url: "URL",
    description: "Descrizione",
    titlePlaceholder: "Inserisci il titolo del segnalibro",
    urlPlaceholder: "Inserisci l'URL del sito web (es: google.com)",
    descriptionPlaceholder: "Descrizione opzionale",
    updateBookmark: "Aggiorna segnalibro",
    addBookmarkBtn: "Aggiungi segnalibro",
    cancel: "Annulla",
    saving: "Salvataggio...",
    
    // Bookmark item actions
    visit: "🔗 Visita",
    open: "Apri",
    edit: "Modifica",
    delete: "Elimina",
    share: "Condividi",
    remindMe: "Ricordami",

    // Reminder dialog
    createReminder: "Crea promemoria",
    frequency: "Frequenza",
    reminderOnce: "Una volta",
    reminderDaily: "Giornaliero",
    reminderWeekly: "Settimanale",
    reminderMonthly: "Mensile",
    quickReminder: "Promemoria rapido",
    in30Min: "Tra 30 min",
    in1Hour: "Tra 1 ora",
    in3Hours: "Tra 3 ore",
    tomorrow: "Domani",
    nextWeek: "Prossima settimana",
    customDateTime: "Data e ora personalizzate",
    create: "Crea",
    pleaseSelectDateTime: "Seleziona data e ora",
    notificationsDenied: "Le notifiche push sono bloccate. Abilitale nelle impostazioni del browser.",
    reminderCreated: "Promemoria creato!",

    // Search and sort
    searchBookmarks: "Cerca... (es. \"3 stelle\" o \"2 stelle torta\")",
    searchPlaceholder: "🔍 Cerca segnalibri...",
    sortBy: "Ordina per:",
    newest: "Più recenti prima",
    oldest: "Più vecchi prima",
    titleSort: "Titolo A-Z",
    urlSort: "URL A-Z",
    favorites: "Solo preferiti",
    
    // Favorites
    addToFavorites: "Aggiungi ai preferiti",
    removeFromFavorites: "Rimuovi dai preferiti",
    showFavorites: "Mostra preferiti",
    showAll: "Mostra tutti",
    
    // Empty state
    noBookmarks: "Nessun segnalibro ancora!",
    noBookmarksDesc: "Aggiungi il tuo primo segnalibro per iniziare.",
    noResults: "Nessun segnalibro trovato per",
    noResultsFound: "Nessun risultato trovato",
    tryDifferentSearch: "Prova con un altro termine di ricerca",

    // Bookmark details
    fullUrl: "URL completo:",
    created: "Creato:",
    updated: "Aggiornato:",
    
    // Footer
    totalBookmarks: "Totale segnalibri:",
    
    // Pagination
    showing: "Mostrando",
    of: "di",
    bookmarks: "segnalibri",
    previous: "Precedente",
    next: "Successivo",
    
    // Validation messages
    titleRequired: "Il titolo è richiesto",
    urlRequired: "L'URL è richiesto",
    invalidUrl: "Per favore inserisci un URL valido",
    
    // Confirmation
    deleteConfirm: "Sei sicuro di voler eliminare questo segnalibro?",
    logoutConfirm: "Sei sicuro di voler uscire?",
    
    // Authentication
    login: "Accedi",
    register: "Registrati",
    logout: "Esci",
    email: "Email",
    password: "Password",
    name: "Nome",
    confirmPassword: "Conferma password",
    emailPlaceholder: "Inserisci il tuo indirizzo email",
    passwordPlaceholder: "Inserisci la tua password",
    namePlaceholder: "Inserisci il tuo nome completo",
    confirmPasswordPlaceholder: "Conferma la tua password",
    loginBtn: "Accedi",
    registerBtn: "Crea account",
    loading: "Caricamento...",
    forgotPassword: "Password dimenticata?",
    noAccount: "Non hai un account?",
    hasAccount: "Hai già un account?",
    registerLink: "Registrati",
    loginLink: "Accedi",
    welcomeBack: "Bentornato",
    loggedInAs: "Connesso come",
    
    // Validation messages
    emailRequired: "L'email è richiesta",
    passwordRequired: "La password è richiesta",
    nameRequired: "Il nome è richiesto",
    invalidEmail: "Per favore inserisci un indirizzo email valido",
    passwordTooShort: "La password deve essere di almeno 6 caratteri",
    passwordsDoNotMatch: "Le password non corrispondono",
    
    goOnline: "Vai online",
    goOffline: "Vai offline",
    switchToOnline: "Passa alla modalità online",
    switchToOffline: "Passa alla modalità offline",

    // Voice Control
    voiceControlTitle: "Controllo vocale",
    privacyFirst: "Privacy prima",
    onDeviceProcessing: "Elaborazione sul dispositivo",
    noDataTransmission: "Nessuna trasmissione dati",
    gdprCompliant: "Conforme GDPR",
    exampleCommands: "Comandi di esempio",
    activateVoiceControl: "Attiva controllo vocale",
    continueWithoutVoice: "Continua senza voce",
    loadingModel: "Caricamento modello vocale...",
    listening: "In ascolto...",
    commandNotRecognized: "Comando non riconosciuto",
    commandRecognized: "Comando riconosciuto",
    stopListening: "Ferma ascolto",
    startListening: "Avvia input vocale",
    showVoiceHelp: "Mostra comandi vocali",
    revokeVoiceConsent: "Disattiva controllo vocale",
    voiceCommands: "Comandi vocali",
    closeHelp: "Chiudi aiuto",
    closeError: "Chiudi errore",
    voiceTips: "Suggerimenti",
    speakClearly: "Parla chiaramente a volume normale",
    waitForBeep: "Aspetta l'icona del microfono prima di parlare",
    shortCommands: "Usa comandi brevi e chiari",
    browserBased: "Basato su browser",
    instantReady: "Pronto all'istante",
    privacyNote: "Nota sulla privacy",
    commandCategoryonline: "Modalità online",
    commandCategorysystem: "Sistema",
    
    // Password Reset
    forgotPasswordTitle: "Password dimenticata?",
    forgotPasswordDescription: "Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la tua password.",
    emailSentTitle: "Email inviata",
    emailSentMessage: "Se l'indirizzo email esiste nel nostro sistema, riceverai un link di reset a breve.",
    checkEmailInstruction: "Per favore controlla la tua casella email e segui le istruzioni nell'email.",
    backToLogin: "Torna al login",
    sendResetLink: "Invia link di reset",
    sendingResetLink: "Invio...",
    resetPasswordTitle: "Reimposta password",
    newPassword: "Nuova password",
    confirmNewPassword: "Conferma nuova password",
    newPasswordPlaceholder: "Inserisci la nuova password",
    confirmNewPasswordPlaceholder: "Conferma la nuova password",
    updatePassword: "Aggiorna password",
    updatingPassword: "Aggiornamento...",
    passwordUpdatedTitle: "Password aggiornata",
    passwordUpdatedMessage: "La tua password è stata aggiornata con successo. Ora puoi accedere con la tua nuova password.",
    proceedToLogin: "Continua al login",
    invalidResetToken: "Token di reset non valido o scaduto",
    passwordResetError: "Si è verificato un errore. Per favore riprova più tardi.",
    sessionExpiredSecurity: "Sei stato disconnesso per motivi di sicurezza perché la tua sessione è scaduta.",
    offlineTimeout: "Sei stato offline troppo a lungo. Per favore accedi di nuovo.",
    offlineBanner: "Sei offline. Le modifiche verranno sincronizzate quando la connessione sarà ripristinata.",
    back: "Indietro",
    
    // HamburgerMenu
    categories: "Categorie",
    voiceControl: "Comandi vocali",
    startVoiceInput: "Attiva input vocale",
    stopVoiceInput: "Ferma input vocale",
    themes: "Temi",
    selectTheme: "Temi",
    privacy: "Privacy",
    settings: "Impostazioni",
    support: "Supporto",
    'version.title': 'Versione',
    'version.current': 'Versione attualmente installata',
    'version.upToDate': 'Stai usando la versione più recente.',
    language: "Lingua",
    upgradeBeta: "Prova Beta",

    // Settings
    'settings.notifications': 'Notifiche',
    'settings.pushNotifications': 'Attiva notifiche push',
    'settings.dataBackup': 'Backup dati',
    'settings.autoBackup': 'Backup automatico',
    'settings.general': 'Generale',
    'settings.language': 'Lingua',
    'settings.selectLanguage': 'Seleziona lingua',
    'settings.voiceControl': 'Controllo vocale',
    'settings.voiceActivate': 'Attiva comandi vocali',
    'settings.voicePrivacyRevoke': 'Revocare il consenso vocale',
    'settings.save': 'Salva',
    'settings.saved': 'Impostazioni salvate!',

    // Menu
    'menu.bookmarks': 'Segnalibri',
    'menu.profile': 'Profilo',
    'menu.version': 'Versione',
    'menu.todo': 'Attività',
    'menu.allBookmarks': 'Panoramica',
    'menu.reminders': 'Promemoria',
    'menu.calendar': 'Calendario',

    // Impostazioni di navigazione
    'settings.navigation': 'Navigazione',
    'settings.navDescription': 'Scegli fino a 3 elementi per la barra di navigazione.',
    'settings.navMaxThree': 'Possono essere selezionati massimo 3 elementi',
    'settings.navMinOne': 'Deve essere selezionato almeno 1 elemento',
    'settings.navMoveUp': 'Sposta su',
    'settings.navMoveDown': 'Sposta giù',

    // Impostazioni profilo
    'settings.profile': 'Profilo',
    'settings.profileDescription': 'Gestisci il tuo indirizzo email, la password e il tuo account.',
    'settings.currentEmail': 'Indirizzo email',
    'settings.newEmail': 'Nuovo indirizzo email',
    'settings.changeEmail': 'Cambia indirizzo email',
    'settings.applyChange': 'Aggiorna',
    'settings.emailChanged': 'Indirizzo email modificato con successo.',
    'settings.emailChangeError': "Errore durante la modifica dell'indirizzo email. Riprova.",
    'settings.currentPassword': 'Password attuale',
    'settings.newPassword': 'Nuova password',
    'settings.confirmNewPassword': 'Conferma nuova password',
    'settings.changePasswordBtn': 'Cambia password',
    'settings.passwordChanged': 'Password modificata con successo.',
    'settings.passwordChangeError': 'Errore durante la modifica della password. Controlla la tua password attuale.',
    'settings.deleteAccountTitle': 'Elimina account',
    'settings.deleteAccountWarning': 'Elimina definitivamente tutti i tuoi dati (segnalibri, liste della spesa, ricette, promemoria, link condivisi). Azione irreversibile.',
    'settings.deleteAccountPasswordLabel': 'Conferma con la tua password',
    'settings.deleteAccountButton': '🗑️ Elimina definitivamente',
    'settings.deleteAccountConfirm': 'Sei sicuro di voler eliminare definitivamente il tuo account? Tutti i tuoi dati verranno cancellati in modo irrevocabile. Questa azione non può essere annullata.',
    'settings.accountDeleted': 'Il tuo account è stato eliminato con successo.',
    'settings.accountDeleteError': "Errore durante l'eliminazione dell'account. Riprova o contatta il supporto.",
    'settings.passwordRequiredForAction': 'Inserisci la tua password per confermare.',
    'settings.confirmWithPassword': 'Conferma la modifica con la tua password',
    'settings.nothingToChange': 'Inserisci un nuovo indirizzo email e/o una nuova password.',

    'nav.bookmarks': 'Segnalibri',
    'nav.reminders': 'Promemoria',
    'nav.quickList': 'Lista della spesa',
    'nav.todo': 'Attività',
    'nav.recipes': 'Ricette',

    // Promemoria (vista calendario + dialogo di creazione)
    'reminders.title': 'Calendario',
    'reminders.month': 'Mese',
    'reminders.week': 'Settimana',
    'reminders.today': 'Oggi',
    'reminders.previous': 'Precedente',
    'reminders.next': 'Successivo',
    'reminders.viewMode': 'Vista',
    'reminders.noRemindersThisDay': 'Nessun promemoria in questo giorno',
    'reminders.deleteConfirm': 'Eliminare davvero questo promemoria?',
    'reminders.frequencyCustom': 'Personalizzato',
    'reminders.editTitle': 'Modifica promemoria',
    'reminders.titleLabel': 'Titolo',
    'reminders.titleRequired': 'Inserisci un titolo',
    'reminders.save': 'Salva',
    'reminders.saving': 'Salvataggio...',
    'reminders.saved': 'Promemoria aggiornato.',
    'reminders.saveError': 'Errore durante il salvataggio.',
    'reminders.close': 'Chiudi',
    'reminders.editAction': 'Modifica',
    'reminders.deleteAction': 'Elimina',
    'reminders.activate': 'Attiva',
    'reminders.deactivate': 'Disattiva',
    'reminders.openBookmark': 'Apri segnalibro',

    // Export/Share functionality
    exportBookmarks: "Esporta segnalibri",
    exportCompleted: "Esportazione completata!",
    exportSuccessMessage: "I tuoi segnalibri sono stati esportati con successo. Il file è stato salvato nella cartella Downloads.",
    shareBookmark: "Condividi segnalibro",
    copyLink: "Copia link",
    linkCopied: "Link copiato negli appunti!",
    copyFailed: "Copia fallita",

    // Opzioni impostazioni
    autoRemoveInvalidLinks: "Rimuovi automaticamente link non validi",
    autoRemoveInactiveReminders: "Rimuovi automaticamente promemoria disattivati",

    // Menu Ricette
    'menu.recipes': 'Ricette',
    'menu.recipesOverview': 'La mia collezione',
    'menu.shoppingList': 'Spesa',
    'menu.quickList': 'Spesa di oggi',
    'menu.archive': 'Archivio ricette',
    'menu.dataArchive': 'Archivio',

    // Lista della spesa veloce
    'quickList.title': 'Spesa di oggi',
    'quickList.addItem': 'Aggiungi articolo',
    'quickList.progress': '{completed} di {total} completato',
    'quickList.error': 'Errore nel caricamento',
    'quickList.addError': 'Errore nell\'aggiunta',
    'quickList.placeholder': 'Aggiungi articolo...',
    'quickList.empty': 'Nessun articolo ancora',
    'quickList.emptyHint': 'Aggiungi il tuo primo articolo!',
    'quickTodo.error': 'Errore nel caricamento della lista delle attività',
    'quickTodo.duplicateItem': 'L\'attività è già nella lista',
    'quickTodo.addError': 'Errore nell\'aggiunta',
    'quickTodo.removeError': 'Errore nella rimozione',
    'quickTodo.progress': '{completed} di {total} completato',
    'quickTodo.placeholder': 'Aggiungi attività...',
    'quickTodo.sharedList': 'Lista di attività condivisa',
    'quickTodo.privateList': 'Lista di attività privata',
    'quickTodo.activelyShared': '(Condivisa attivamente)',
    'quickTodo.primaryList': '(Lista principale)',
    'quickTodo.private': '(Privata)',
    'quickTodo.refresh': 'Aggiorna',
    'quickTodo.switchList': 'Gestisci liste',
    'quickTodo.switchListTitle': 'Scegli lista di attività',
    'quickTodo.noOtherLists': 'Nessun\'altra lista disponibile',
    'quickTodo.newList': 'Crea nuova lista',
    'quickTodo.slotPrimary': 'Lista principale',
    'quickTodo.slotSecondary': 'Seconda lista',
    'quickTodo.confirmDeleteList': 'Eliminare definitivamente questa lista?',
    'quickTodo.deleteListError': 'Errore nell\'eliminazione della lista',
    'quickTodo.empty': 'Nessuna attività ancora',
    'quickTodo.emptyHint': 'Aggiungi la tua prima attività!',
    'quickTodo.addSecondary': 'Seconda lista di attività',
    'quickTodo.removeSecondary': 'Rimuovi seconda lista',
    'quickTodo.addSecondaryError': 'Errore nella creazione della seconda lista',
    'quickList.viewAll': 'Tutte le liste',
    'quickList.refresh': 'Aggiorna',
    'quickList.switchList': 'Gestisci liste',
    'quickList.switchListTitle': 'Scegli lista della spesa',
    'quickList.noOtherLists': 'Nessun\'altra lista disponibile',
    'quickList.newList': 'Crea nuova lista',
    'quickList.slotPrimary': 'Lista principale',
    'quickList.slotSecondary': 'Seconda lista',
    'quickList.confirmDeleteList': 'Eliminare definitivamente questa lista?',
    'quickList.deleteListError': 'Errore nell\'eliminazione della lista',
    'quickList.sharedList': 'Lista condivisa',
    'quickList.privateList': 'Lista privata',
    'quickList.activelyShared': '(Condivisa attivamente)',
    'quickList.private': '(Privata)',
    'quickList.setAsSecondary': 'Imposta come seconda lista "Oggi"',
    'quickList.removeSecondary': 'Rimuovi da "Oggi"',
    'quickList.primaryList': '(Lista principale)',

    // Condivisione
    'share.title': 'Condividi lista',
    'share.shareList': 'Condividi',
    'share.sharedList': 'Lista condivisa',
    'share.linkTab': 'Link',
    'share.collaboratorsTab': 'Collaboratori',
    'share.createLink': 'Crea link',
    'share.copy': 'Copia',
    'share.copied': 'Copiato!',
    'share.shareVia': 'Condividi via...',
    'share.expiresIn24h': 'Link valido 24 ore',
    'share.description': 'Crea un link e condividilo. Chiunque con il link può modificare la lista.',
    'share.activeShares': 'Link attivi',
    'share.uses': 'utilizzi',
    'share.revoke': 'Revoca',
    'share.noCollaborators': 'Nessun collaboratore ancora',
    'share.removeCollaborator': 'Rimuovi',
    'share.onlyOwnerCanShare': 'Solo il proprietario può condividere questa lista.',
    'share.error': 'Errore nella creazione del link',
    'share.defaultTitle': 'Lista della spesa',
    'share.inviteText': 'Unisciti alla mia lista della spesa',
    'share.invalidLink': 'Link non valido',
    'share.loadError': 'Errore nel caricamento',
    'share.joinError': 'Errore nell\'unirsi',
    'share.invalidTitle': 'Link non valido',
    'share.backHome': 'Torna alla home',
    'share.joinTitle': 'Unisciti alla lista',
    'share.listName': 'Lista',
    'share.owner': 'Creata da',
    'share.items': 'Articoli',
    'share.expiresIn': 'Valido ancora',
    'share.expired': 'Scaduto',
    'share.joinNow': 'Unisciti ora',
    'share.loginToJoin': 'Accedi',
    'share.cancel': 'Annulla',
    'share.loginRequired': 'Devi accedere per unirti alla lista.',
    'share.loading': 'Caricamento...',
    'share.alreadyMember': 'Sei già membro',
    'share.joinSuccess': 'Unito con successo!',
    'share.redirecting': 'Reindirizzamento...',

    // Elenco ricette
    'recipes.title': 'Ricette',
    'recipes.searchPlaceholder': 'Cerca ricette...',
    'recipes.noRecipes': 'Nessuna ricetta trovata',
    'recipes.noRecipesHint': 'I segnalibri con parole chiave come "ricetta", "ingredienti" vengono rilevati automaticamente',
    'recipes.createShoppingList': 'Crea lista della spesa',
    'recipes.viewRecipe': 'Visualizza ricetta',
    'recipes.archive': 'Archivia',
    'recipes.confirmArchive': 'Archiviare questa ricetta?',
    'recipes.archived': 'La ricetta è stata archiviata',
    'recipes.listCreated': 'Lista della spesa creata!',
    'recipes.addedToCart': 'Aggiunto al carrello!',
    'recipes.addToShoppingList': 'Aggiungi alla lista',
    'recipes.addedToList': 'Aggiunto alla lista della spesa!',
    'recipes.listAddError': 'Errore durante l\'aggiunta alla lista',
    'recipes.pickShoppingList': 'A quale lista della spesa vuoi aggiungerlo?',
    'recipes.newShoppingList': '+ Crea nuova lista',
    'recipes.newShoppingListPlaceholder': 'Nome della nuova lista (opzionale)',
    'recipes.noIngredients': 'Nessun ingrediente disponibile per questa ricetta. Modifica la ricetta e aggiungi gli ingredienti.',
    'recipes.extractionInfo': 'Gli ingredienti di questa ricetta non sono ancora stati caricati. Clicca sul pulsante per caricare automaticamente gli ingredienti dal sito web.',
    'recipes.extractIngredients': 'Carica ingredienti dal sito web',
    'recipes.extracting': 'Caricamento ingredienti...',
    'recipes.extractionError': 'Errore nel caricamento degli ingredienti. Il sito web potrebbe non supportare il rilevamento automatico.',
    'recipes.instagramNotSupported': 'Instagram non supporta l\'estrazione automatica delle ricette. Puoi creare la ricetta manualmente.',
    'recipes.createManually': 'Crea ricetta manualmente',
    'recipes.openInInstagram': 'Apri in Instagram',
    'recipes.viewOriginal': 'Visualizza ricetta originale',
    'recipes.addToCart': 'Aggiungi al carrello',
    'recipes.baseServings': 'Porzioni base',
    'recipes.targetServings': 'Porzioni desiderate',
    'recipes.ingredients': 'Ingredienti',
    'recipes.manualRecipes': 'Le mie ricette',
    'recipes.bookmarkRecipes': 'Segnalibri delle ricette',
    'recipes.servings': 'Porzioni',
    'recipes.quantity': 'Quantità',
    'recipes.unit': 'Unità',
    'recipes.ingredient': 'Ingrediente',
    'recipes.note': 'Nota',
    'recipes.servingsQuestion': 'Per quante persone vuoi cucinare?',
    'recipes.confirm': 'Conferma',
    'recipes.cancel': 'Annulla',
    'recipes.close': 'Chiudi',
    'recipes.print': 'Stampa',
    'recipes.instructions': 'Preparazione',
    'recipes.addStep': 'Aggiungi passaggio',
    'recipes.removeStep': 'Rimuovi passaggio',
    'recipes.stepPlaceholder': 'Descrivi questo passaggio di preparazione...',
    'recipes.notOnlineRecipeHint': 'Questa non è una ricetta online. Usa il pulsante di menu "Visualizza ricetta".',

    // Modulo ricetta (CRUD)
    'recipes.form.createTitle': 'Crea nuova ricetta',
    'recipes.form.editTitle': 'Modifica ricetta',
    'recipes.form.saveAndClose': 'Salva e chiudi',
    'recipes.form.newRecipe': 'Nuova ricetta',
    'recipes.form.title': 'Nome della ricetta',
    'recipes.form.titleRequired': 'Il nome della ricetta è obbligatorio',
    'recipes.form.description': 'Descrizione',
    'recipes.form.baseServings': 'Porzioni base',
    'recipes.form.servingsInvalid': 'Richiesta almeno 1 porzione',
    'recipes.form.difficulty': 'Difficoltà',
    'recipes.form.prepTime': 'Tempo di preparazione',
    'recipes.form.cookTime': 'Tempo di cottura',
    'recipes.form.minutes': 'minuti',
    'recipes.form.addIngredient': 'Aggiungi ingrediente',
    'recipes.form.ingredientName': 'Ingrediente',
    'recipes.form.note': 'Nota',
    'recipes.form.create': 'Crea ricetta',
    'recipes.form.update': 'Aggiorna ricetta',
    'recipes.form.confirmDelete': 'Eliminare davvero questa ricetta?',
    'recipes.form.deleteSuccess': 'Ricetta eliminata',
    'recipes.form.createSuccess': 'Ricetta creata',
    'recipes.form.updateSuccess': 'Ricetta aggiornata',
    'recipes.difficulty.easy': 'Facile',
    'recipes.difficulty.medium': 'Medio',
    'recipes.difficulty.hard': 'Difficile',

    // Lista della spesa
    'shoppingList.title': 'Liste della spesa',
    'shoppingList.all': 'Tutte',
    'shoppingList.open': 'Aperte',
    'shoppingList.completed': 'Completate',
    'shoppingList.noLists': 'Nessuna lista della spesa',
    'shoppingList.noListsHint': 'Crea una lista della spesa da una ricetta',
    'shoppingList.items': 'articoli',
    'shoppingList.created': 'Creato',
    'shoppingList.selectList': 'Seleziona una lista della spesa',
    'shoppingList.confirmDelete': 'Eliminare questa lista della spesa?',
    'shoppingList.edit': 'Modifica',
    'shoppingList.save': 'Salva',
    'shoppingList.cancel': 'Annulla',
    'shoppingList.addItem': 'Aggiungi articolo',
    'shoppingList.newItemPlaceholder': 'ad es. Pomodori',
    'shoppingList.empty': 'Nessuna lista della spesa',
    'shoppingList.backToList': 'Torna alla panoramica',
    'shoppingList.more': 'altri',
    'shoppingList.editMode': 'Modifica lista della spesa',
    'shoppingList.newList': '+ Nuova lista della spesa',
    'shoppingList.manualTitle': 'Nuova lista della spesa',
    'shoppingList.name': 'Nome',
    'shoppingList.namePlaceholder': 'ad es. Spesa settimanale, Ferramenta, Festa sabato',
    'shoppingList.description': 'Descrizione (opzionale)',
    'shoppingList.descriptionPlaceholder': 'Note per la lista della spesa...',
    'shoppingList.create': 'Crea',
    'shoppingList.nameRequired': 'Inserisci un nome',
    'shoppingList.itemName': 'Articolo',
    'shoppingList.itemQuantity': 'Quantità',
    'shoppingList.itemUnit': 'Unità',
    'shoppingList.searchPlaceholder': 'Cerca liste...',
    'shoppingList.noResults': 'Nessuna lista trovata',
    'shoppingList.enterListName': 'Inserire nome lista...',
    'shoppingList.addDescription': 'Aggiungi descrizione',
    'shoppingList.confirmName': 'Conferma nome',
    'shoppingList.addItemPlaceholder': 'Aggiungi articolo...',

    // Archivio
    'archive.title': 'Archivio ricette',
    'archive.info': 'L\'archivio memorizza le ricette come snapshot nel caso in cui l\'URL originale scompaia o un lavoro di pulizia rimuova i segnalibri non validi.',
    'archive.noArchived': 'Nessuna ricetta archiviata',
    'archive.noArchivedHint': 'Archivia le ricette per mantenere una copia permanente',
    'archive.open': 'Apri',
    'archive.archivedOn': 'Archiviato il',

    // Archivio dati (cestino / ripristino per categorie, segnalibri, ricette, liste della spesa)
    'dataArchive.title': 'Archivio',
    'dataArchive.intro': 'Le categorie, i segnalibri, le ricette e le liste della spesa eliminati finiscono automaticamente qui e possono essere ripristinati da qui.',
    'dataArchive.filterAll': 'Tutti',
    'dataArchive.empty': 'Nessun elemento archiviato',
    'dataArchive.emptyHint': 'Le categorie, i segnalibri, le ricette e le liste della spesa eliminati appariranno qui.',
    'dataArchive.badgeDeleted': 'Eliminato',
    'dataArchive.badgeSnapshot': 'Backup automatico',
    'dataArchive.restore': 'Ripristina',
    'dataArchive.restoreSuccess': 'Ripristinato con successo',
    'dataArchive.restoreError': 'Ripristino non riuscito',
    'dataArchive.restoreExists': 'Esiste già, non ripristinato',
    'dataArchive.removeConfirm': 'Rimuovere definitivamente questa voce dall\'archivio? (Non può essere annullato)',
    'dataArchive.removePermanently': 'Rimuovi definitivamente',
    'dataArchive.noTitle': '(senza titolo)',
    'dataArchive.viewContent': 'Visualizza contenuto',
    'dataArchive.source': 'Fonte',
    'dataArchive.author': 'Autore',
    'dataArchive.archivedNotice': 'Versione archiviata del {date} – originale disponibile nel link sopra. Il contenuto potrebbe essere cambiato o non più disponibile.',
    'dataArchive.removeError': 'Rimozione non riuscita',
    'dataArchive.contentNotFound': 'Nessun contenuto archiviato disponibile.',
    'archive.originalUrl': 'URL originale',
    'archive.category': 'Categoria',
    'archive.snapshot': 'Snapshot',

    // Modulo segnalibro
    rating: "Valutazione",
    category: "Categoria",
    noRating: "Nessuna valutazione",
    createCategory: "Crea",
    hideInput: "Nascondi input",
    newCategoryTitle: "Crea nuova categoria",
    newCategoryPlaceholder: "Inserisci nuova categoria...",

    // Categorie segnalibri (rilevamento automatico)
    'categories.work': 'Lavoro',
    'categories.dev': 'Dev',
    'categories.ai': 'IA',
    'categories.design': 'Design',
    'categories.tools': 'Strumenti',
    'categories.news': 'Notizie',
    'categories.shopping': 'Shopping',
    'categories.deals': 'Offerte',
    'categories.finance': 'Finanze',
    'categories.food': 'Cibo',
    'categories.travel': 'Viaggi',
    'categories.fitness': 'Fitness',
    'categories.entertainment': 'Intrattenimento',
    'categories.gaming': 'Giochi',
    'categories.diy': 'Fai da te',
    'categories.inbox': 'Più tardi',
    'categories.important': 'Importante',
    'categories.random': 'Vari',
    'categories.other': 'Altri',

    // Gestione categorie
    'categories.title': 'Categorie',
    'categories.placeholder': 'Nuova categoria...',
    'categories.add': 'Aggiungi categoria',
    'categories.empty': 'Nessuna categoria ancora',
    'categories.emptyHint': 'Digita un nome qui sopra e tocca + per creare la tua prima categoria!',
    'categories.emptyError': 'Il nome della categoria non può essere vuoto',
    'categories.existsError': 'La categoria esiste già',
    'categories.deleteConfirm': 'Eliminare la categoria "{name}"? (I segnalibri saranno conservati)',
    'categories.searchPlaceholder': 'Cerca o digita una nuova categoria...',
    'categories.noResults': 'Nessuna categoria trovata',
    'categories.noResultsHint': 'Tocca + qui sopra per aggiungerla come nuova categoria'
  }
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.en[key] || key;
};

// Available languages with their display names and flags
export const availableLanguages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' }
];